import { openBlock as k, createElementBlock as I, createElementVNode as ae, reactive as _t, computed as L, unref as i, ref as H, watch as nt, toRef as St, onMounted as Ue, nextTick as Qe, defineComponent as je, renderSlot as K, createCommentVNode as P, normalizeClass as he, withKeys as ie, createBlock as ve, withModifiers as Je, normalizeStyle as et, normalizeProps as Ne, mergeProps as Se, Fragment as me, createTextVNode as Ze, toDisplayString as Re, renderList as Pe, createVNode as tt, Transition as kt, withCtx as se, onBeforeUpdate as ta, onUnmounted as mn, withDirectives as Bt, vShow as Yt, createSlots as Ve, isRef as ut, guardReactiveProps as ze, resolveDynamicComponent as Ln, useSlots as yn, getCurrentScope as na, onScopeDispose as aa, Teleport as ra } from "vue";
import { isBefore as Pt, isEqual as ht, isAfter as Ct, set as Ce, setHours as Fn, setMinutes as Un, setSeconds as Wn, setMilliseconds as gn, parse as on, isValid as Vt, isDate as la, format as Mt, getMonth as pe, getDay as oa, getYear as we, getHours as qe, getMinutes as Xe, getSeconds as pt, parseISO as sa, startOfWeek as bn, endOfWeek as ia, setMonth as Et, setYear as vt, addDays as dt, add as Hn, addMonths as ct, subMonths as Tt, getWeek as ua, getISOWeek as da, differenceInCalendarDays as ca, eachDayOfInterval as Dn, addYears as fa, subYears as va, sub as ma } from "date-fns";
function Ut() {
  return k(), I(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ae("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      ae("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      ae("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      ae("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
function ya() {
  return k(), I(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ae("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      ae("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
function $n() {
  return k(), I(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ae("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
function Mn() {
  return k(), I(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ae("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
function xn() {
  return k(), I(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ae("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      ae("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
function zn() {
  return k(), I(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ae("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
function Kn() {
  return k(), I(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      ae("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
const Tn = (e, n, a, t, o) => {
  const v = on(e, n.slice(0, e.length), /* @__PURE__ */ new Date());
  return Vt(v) && la(v) ? t || o ? v : Ce(v, {
    hours: +a.hours,
    minutes: +(a == null ? void 0 : a.minutes),
    seconds: +(a == null ? void 0 : a.seconds),
    milliseconds: 0
  }) : null;
}, ga = (e, n, a, t, o) => {
  const v = Array.isArray(a) ? a[0] : a;
  if (typeof n == "string")
    return Tn(e, n, v, t, o);
  if (Array.isArray(n)) {
    let g = null;
    for (const N of n)
      if (g = Tn(e, N, v, t, o), g)
        break;
    return g;
  }
  return typeof n == "function" ? n(e) : null;
}, M = (e) => e ? new Date(e) : /* @__PURE__ */ new Date(), ha = (e, n) => {
  if (n) {
    const t = (e.getMonth() + 1).toString().padStart(2, "0"), o = e.getDate().toString().padStart(2, "0"), v = e.getHours().toString().padStart(2, "0"), g = e.getMinutes().toString().padStart(2, "0");
    return `${e.getFullYear()}-${t}-${o}T${v}:${g}:00.000Z`;
  }
  const a = Date.UTC(
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate(),
    e.getUTCHours(),
    e.getUTCMinutes(),
    e.getUTCSeconds()
  );
  return new Date(a).toISOString();
}, Ke = (e) => {
  let n = M(JSON.parse(JSON.stringify(e)));
  return n = Fn(n, 0), n = Un(n, 0), n = Wn(n, 0), n = gn(n, 0), n;
}, Fe = (e, n, a, t) => {
  let o = e ? M(e) : M();
  return (n || n === 0) && (o = Fn(o, +n)), (a || a === 0) && (o = Un(o, +a)), (t || t === 0) && (o = Wn(o, +t)), gn(o, 0);
}, Oe = (e, n) => !e || !n ? !1 : Pt(Ke(e), Ke(n)), ge = (e, n) => !e || !n ? !1 : ht(Ke(e), Ke(n)), Ye = (e, n) => !e || !n ? !1 : Ct(Ke(e), Ke(n)), jn = (e, n, a) => e && e[0] && e[1] ? Ye(a, e[0]) && Oe(a, e[1]) : e && e[0] && n ? Ye(a, e[0]) && Oe(a, n) || Oe(a, e[0]) && Ye(a, n) : !1, Dt = (e) => {
  const n = Ce(new Date(e), { date: 1 });
  return Ke(n);
}, Zt = (e, n, a) => n && (a || a === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((t) => t === n ? [t, a] : [t, isNaN(+e[t]) ? void 0 : +e[t]])
) : {
  hours: isNaN(+e.hours) ? void 0 : +e.hours,
  minutes: isNaN(+e.minutes) ? void 0 : +e.minutes,
  seconds: isNaN(+e.seconds) ? void 0 : +e.seconds
}, $t = _t({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), Gn = () => {
  const e = (t) => {
    $t.menuFocused = t;
  }, n = (t) => {
    $t.shiftKeyInMenu !== t && ($t.shiftKeyInMenu = t);
  };
  return {
    control: L(() => ({ shiftKeyInMenu: $t.shiftKeyInMenu, menuFocused: $t.menuFocused })),
    setMenuFocused: e,
    setShiftKey: n
  };
};
function hn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Zn = { exports: {} };
(function(e) {
  function n(a) {
    return a && a.__esModule ? a : {
      default: a
    };
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Zn);
var pa = Zn.exports, sn = { exports: {} };
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = a;
  function a(t) {
    if (t === null || t === !0 || t === !1)
      return NaN;
    var o = Number(t);
    return isNaN(o) ? o : o < 0 ? Math.ceil(o) : Math.floor(o);
  }
  e.exports = n.default;
})(sn, sn.exports);
var ka = sn.exports;
const wa = /* @__PURE__ */ hn(ka);
var un = { exports: {} };
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = a;
  function a(t) {
    var o = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
    return o.setUTCFullYear(t.getFullYear()), t.getTime() - o.getTime();
  }
  e.exports = n.default;
})(un, un.exports);
var ba = un.exports;
const An = /* @__PURE__ */ hn(ba);
function Da(e, n) {
  var a = Aa(n);
  return a.formatToParts ? Ma(a, e) : Ta(a, e);
}
var $a = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function Ma(e, n) {
  try {
    for (var a = e.formatToParts(n), t = [], o = 0; o < a.length; o++) {
      var v = $a[a[o].type];
      v >= 0 && (t[v] = parseInt(a[o].value, 10));
    }
    return t;
  } catch (g) {
    if (g instanceof RangeError)
      return [NaN];
    throw g;
  }
}
function Ta(e, n) {
  var a = e.format(n).replace(/\u200E/g, ""), t = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(a);
  return [t[3], t[1], t[2], t[4], t[5], t[6]];
}
var qt = {};
function Aa(e) {
  if (!qt[e]) {
    var n = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), a = n === "06/25/2014, 00:00:00" || n === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    qt[e] = a ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return qt[e];
}
function pn(e, n, a, t, o, v, g) {
  var N = /* @__PURE__ */ new Date(0);
  return N.setUTCFullYear(e, n, a), N.setUTCHours(t, o, v, g), N;
}
var Sn = 36e5, Sa = 6e4, Xt = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function kn(e, n, a) {
  var t, o;
  if (!e || (t = Xt.timezoneZ.exec(e), t))
    return 0;
  var v;
  if (t = Xt.timezoneHH.exec(e), t)
    return v = parseInt(t[1], 10), Pn(v) ? -(v * Sn) : NaN;
  if (t = Xt.timezoneHHMM.exec(e), t) {
    v = parseInt(t[1], 10);
    var g = parseInt(t[2], 10);
    return Pn(v, g) ? (o = Math.abs(v) * Sn + g * Sa, v > 0 ? -o : o) : NaN;
  }
  if (_a(e)) {
    n = new Date(n || Date.now());
    var N = a ? n : Pa(n), F = dn(N, e), C = a ? F : Ca(n, F, e);
    return -C;
  }
  return NaN;
}
function Pa(e) {
  return pn(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function dn(e, n) {
  var a = Da(e, n), t = pn(
    a[0],
    a[1] - 1,
    a[2],
    a[3] % 24,
    a[4],
    a[5],
    0
  ).getTime(), o = e.getTime(), v = o % 1e3;
  return o -= v >= 0 ? v : 1e3 + v, t - o;
}
function Ca(e, n, a) {
  var t = e.getTime(), o = t - n, v = dn(new Date(o), a);
  if (n === v)
    return n;
  o -= v - n;
  var g = dn(new Date(o), a);
  return v === g ? v : Math.max(v, g);
}
function Pn(e, n) {
  return -23 <= e && e <= 23 && (n == null || 0 <= n && n <= 59);
}
var Cn = {};
function _a(e) {
  if (Cn[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), Cn[e] = !0, !0;
  } catch {
    return !1;
  }
}
var Na = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
const qn = Na;
var Jt = 36e5, _n = 6e4, Ra = 2, Be = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: qn
};
function cn(e, n) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var a = n || {}, t = a.additionalDigits == null ? Ra : wa(a.additionalDigits);
  if (t !== 2 && t !== 1 && t !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var o = Oa(e), v = Ia(o.date, t), g = v.year, N = v.restDateString, F = Ba(N, g);
  if (isNaN(F))
    return /* @__PURE__ */ new Date(NaN);
  if (F) {
    var C = F.getTime(), W = 0, _;
    if (o.time && (W = Ya(o.time), isNaN(W)))
      return /* @__PURE__ */ new Date(NaN);
    if (o.timeZone || a.timeZone) {
      if (_ = kn(o.timeZone || a.timeZone, new Date(C + W)), isNaN(_))
        return /* @__PURE__ */ new Date(NaN);
    } else
      _ = An(new Date(C + W)), _ = An(new Date(C + W + _));
    return new Date(C + W + _);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function Oa(e) {
  var n = {}, a = Be.dateTimePattern.exec(e), t;
  if (a ? (n.date = a[1], t = a[3]) : (a = Be.datePattern.exec(e), a ? (n.date = a[1], t = a[2]) : (n.date = null, t = e)), t) {
    var o = Be.timeZone.exec(t);
    o ? (n.time = t.replace(o[1], ""), n.timeZone = o[1].trim()) : n.time = t;
  }
  return n;
}
function Ia(e, n) {
  var a = Be.YYY[n], t = Be.YYYYY[n], o;
  if (o = Be.YYYY.exec(e) || t.exec(e), o) {
    var v = o[1];
    return {
      year: parseInt(v, 10),
      restDateString: e.slice(v.length)
    };
  }
  if (o = Be.YY.exec(e) || a.exec(e), o) {
    var g = o[1];
    return {
      year: parseInt(g, 10) * 100,
      restDateString: e.slice(g.length)
    };
  }
  return {
    year: null
  };
}
function Ba(e, n) {
  if (n === null)
    return null;
  var a, t, o, v;
  if (e.length === 0)
    return t = /* @__PURE__ */ new Date(0), t.setUTCFullYear(n), t;
  if (a = Be.MM.exec(e), a)
    return t = /* @__PURE__ */ new Date(0), o = parseInt(a[1], 10) - 1, Rn(n, o) ? (t.setUTCFullYear(n, o), t) : /* @__PURE__ */ new Date(NaN);
  if (a = Be.DDD.exec(e), a) {
    t = /* @__PURE__ */ new Date(0);
    var g = parseInt(a[1], 10);
    return La(n, g) ? (t.setUTCFullYear(n, 0, g), t) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = Be.MMDD.exec(e), a) {
    t = /* @__PURE__ */ new Date(0), o = parseInt(a[1], 10) - 1;
    var N = parseInt(a[2], 10);
    return Rn(n, o, N) ? (t.setUTCFullYear(n, o, N), t) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = Be.Www.exec(e), a)
    return v = parseInt(a[1], 10) - 1, On(n, v) ? Nn(n, v) : /* @__PURE__ */ new Date(NaN);
  if (a = Be.WwwD.exec(e), a) {
    v = parseInt(a[1], 10) - 1;
    var F = parseInt(a[2], 10) - 1;
    return On(n, v, F) ? Nn(n, v, F) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function Ya(e) {
  var n, a, t;
  if (n = Be.HH.exec(e), n)
    return a = parseFloat(n[1].replace(",", ".")), Qt(a) ? a % 24 * Jt : NaN;
  if (n = Be.HHMM.exec(e), n)
    return a = parseInt(n[1], 10), t = parseFloat(n[2].replace(",", ".")), Qt(a, t) ? a % 24 * Jt + t * _n : NaN;
  if (n = Be.HHMMSS.exec(e), n) {
    a = parseInt(n[1], 10), t = parseInt(n[2], 10);
    var o = parseFloat(n[3].replace(",", "."));
    return Qt(a, t, o) ? a % 24 * Jt + t * _n + o * 1e3 : NaN;
  }
  return null;
}
function Nn(e, n, a) {
  n = n || 0, a = a || 0;
  var t = /* @__PURE__ */ new Date(0);
  t.setUTCFullYear(e, 0, 4);
  var o = t.getUTCDay() || 7, v = n * 7 + a + 1 - o;
  return t.setUTCDate(t.getUTCDate() + v), t;
}
var Va = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Ea = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Xn(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function Rn(e, n, a) {
  if (n < 0 || n > 11)
    return !1;
  if (a != null) {
    if (a < 1)
      return !1;
    var t = Xn(e);
    if (t && a > Ea[n] || !t && a > Va[n])
      return !1;
  }
  return !0;
}
function La(e, n) {
  if (n < 1)
    return !1;
  var a = Xn(e);
  return !(a && n > 366 || !a && n > 365);
}
function On(e, n, a) {
  return !(n < 0 || n > 52 || a != null && (a < 0 || a > 6));
}
function Qt(e, n, a) {
  return !(e != null && (e < 0 || e >= 25) || n != null && (n < 0 || n >= 60) || a != null && (a < 0 || a >= 60));
}
var fn = { exports: {} }, vn = { exports: {} };
(function(e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = a;
  function a(t, o) {
    if (t == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var v in o)
      Object.prototype.hasOwnProperty.call(o, v) && (t[v] = o[v]);
    return t;
  }
  e.exports = n.default;
})(vn, vn.exports);
var Fa = vn.exports;
(function(e, n) {
  var a = pa.default;
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = o;
  var t = a(Fa);
  function o(v) {
    return (0, t.default)({}, v);
  }
  e.exports = n.default;
})(fn, fn.exports);
var Ua = fn.exports;
const Wa = /* @__PURE__ */ hn(Ua);
function Ha(e, n, a) {
  var t = cn(e, a), o = kn(n, t, !0), v = new Date(t.getTime() - o), g = /* @__PURE__ */ new Date(0);
  return g.setFullYear(v.getUTCFullYear(), v.getUTCMonth(), v.getUTCDate()), g.setHours(v.getUTCHours(), v.getUTCMinutes(), v.getUTCSeconds(), v.getUTCMilliseconds()), g;
}
function xa(e, n, a) {
  if (typeof e == "string" && !e.match(qn)) {
    var t = Wa(a);
    return t.timeZone = n, cn(e, t);
  }
  var o = cn(e, a), v = pn(
    o.getFullYear(),
    o.getMonth(),
    o.getDate(),
    o.getHours(),
    o.getMinutes(),
    o.getSeconds(),
    o.getMilliseconds()
  ).getTime(), g = kn(n, new Date(v));
  return new Date(v + g);
}
const za = (e, n = 3) => {
  const a = [];
  for (let t = 0; t < e.length; t += n)
    a.push([e[t], e[t + 1], e[t + 2]]);
  return a;
}, Ka = (e, n) => {
  const a = [1, 2, 3, 4, 5, 6, 7].map((v) => new Intl.DateTimeFormat(e, { weekday: "short", timeZone: "UTC" }).format(/* @__PURE__ */ new Date(`2017-01-0${v}T00:00:00+00:00`)).slice(0, 2)), t = a.slice(0, n), o = a.slice(n + 1, a.length);
  return [a[n]].concat(...o).concat(...t);
}, ja = (e, n) => {
  const a = [];
  for (let t = +e[0]; t <= +e[1]; t++)
    a.push({ value: +t, text: `${t}` });
  return n ? a.reverse() : a;
}, Ga = (e, n) => {
  const a = new Intl.DateTimeFormat(e, { month: n, timeZone: "UTC" });
  return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((o) => {
    const v = o < 10 ? `0${o}` : o;
    return /* @__PURE__ */ new Date(`2017-${v}-01T00:00:00+00:00`);
  }).map((o, v) => ({
    text: a.format(o),
    value: v
  }));
}, Za = (e) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][e], $e = (e) => {
  const n = i(e);
  return n != null && n.$el ? n == null ? void 0 : n.$el : n;
}, qa = (e) => Object.assign({ type: "dot" }, e), Jn = (e) => Array.isArray(e) ? !!e[0] && !!e[1] : !1, Ft = {
  prop: (e) => `"${e}" prop must be enabled!`,
  dateArr: (e) => `You need to use array as "model-value" binding in order to support "${e}"`
}, Ae = (e) => e, In = (e) => e === 0 ? e : !e || isNaN(+e) ? null : +e, Bn = (e) => Object.assign(
  {
    menuAppear: "dp-menu-appear",
    open: "dp-slide-down",
    close: "dp-slide-up",
    next: "calendar-next",
    previous: "calendar-prev",
    vNext: "dp-slide-up",
    vPrevious: "dp-slide-down"
  },
  e
), Xa = (e) => Object.assign(
  {
    toggleOverlay: "Toggle overlay",
    menu: "Datepicker menu",
    input: "Datepicker input",
    calendarWrap: "Calendar wrapper",
    calendarDays: "Calendar days",
    openTimePicker: "Open time picker",
    closeTimePicker: "Close time Picker",
    incrementValue: (n) => `Increment ${n}`,
    decrementValue: (n) => `Decrement ${n}`,
    openTpOverlay: (n) => `Open ${n} overlay`,
    amPmButton: "Switch AM/PM mode",
    openYearsOverlay: "Open years overlay",
    openMonthsOverlay: "Open months overlay",
    nextMonth: "Next month",
    prevMonth: "Previous month",
    day: () => ""
  },
  e
), Ja = (e) => e === null ? 0 : typeof e == "boolean" ? e ? 2 : 0 : +e >= 2 ? +e : 2, Qa = (e, n, a) => e || (typeof a == "string" ? a : n), er = (e) => typeof e == "boolean" ? e ? Bn({}) : !1 : Bn(e), tr = () => ({
  enterSubmit: !0,
  tabSubmit: !0,
  openMenu: !0,
  rangeSeparator: " - "
}), nr = (e) => Object.assign({ months: [], years: [], times: { hours: [], minutes: [], seconds: [] } }, e), ar = (e) => Object.assign({ showSelect: !0, showCancel: !0, showNow: !1, showPreview: !0 }, e), Ee = (e) => {
  const n = () => {
    if (e.partialRange)
      return null;
    throw new Error(Ft.prop("partial-range"));
  }, a = L(() => ({
    ariaLabels: Xa(e.ariaLabels),
    textInputOptions: Object.assign(tr(), e.textInputOptions),
    multiCalendars: Ja(e.multiCalendars),
    previewFormat: Qa(e.previewFormat, e.format, v()),
    filters: nr(e.filters),
    transitions: er(e.transitions),
    startTime: d(),
    actionRow: ar(e.actionRow)
  })), t = (u) => {
    if (e.range)
      return u();
    throw new Error(Ft.prop("range"));
  }, o = () => {
    const u = e.enableSeconds ? ":ss" : "";
    return e.is24 ? `HH:mm${u}` : `hh:mm${u} aa`;
  }, v = () => e.format ? e.format : e.monthPicker ? "MM/yyyy" : e.timePicker ? o() : e.weekPicker ? "MM/dd/yyyy" : e.yearPicker ? "yyyy" : e.enableTimePicker ? `MM/dd/yyyy, ${o()}` : "MM/dd/yyyy", g = (u, l) => {
    if (typeof e.format == "function")
      return e.format(u);
    const r = l || v(), p = e.formatLocale ? { locale: e.formatLocale } : void 0;
    return Array.isArray(u) ? `${Mt(u[0], r, p)} ${e.modelAuto && !u[1] ? "" : a.value.textInputOptions.rangeSeparator || "-"} ${u[1] ? Mt(u[1], r, p) : ""}` : Mt(u, r, p);
  }, N = (u) => e.timezone ? Ha(u, e.timezone) : u, F = (u) => e.timezone ? xa(u, e.timezone) : u, C = L(() => (u) => {
    var l;
    return (l = e.hideNavigation) == null ? void 0 : l.includes(u);
  }), W = (u) => {
    const l = e.maxDate ? Ye(N(u), N(M(e.maxDate))) : !1, r = e.minDate ? Oe(N(u), N(M(e.minDate))) : !1, p = V(u, e.disabledDates), A = a.value.filters.months.map((le) => +le).includes(pe(u)), c = e.disabledWeekDays.length ? e.disabledWeekDays.some((le) => +le === oa(u)) : !1, S = e.allowedDates.length ? !e.allowedDates.some((le) => ge(N(M(le)), N(u))) : !1, f = we(u), E = f < +e.yearRange[0] || f > +e.yearRange[1];
    return !(l || r || p || A || E || c || S);
  }, _ = (u) => {
    const l = {
      hours: qe(M()),
      minutes: Xe(M()),
      seconds: e.enableSeconds ? pt(M()) : 0
    };
    return Object.assign(l, u);
  }, d = () => e.range ? e.startTime && Array.isArray(e.startTime) ? [_(e.startTime[0]), _(e.startTime[1])] : null : e.startTime && !Array.isArray(e.startTime) ? _(e.startTime) : null, $ = (u) => !W(u), X = (u) => Array.isArray(u) ? Vt(u[0]) && (u[1] ? Vt(u[1]) : !0) : u ? Vt(u) : !1, G = (u) => u instanceof Date ? u : sa(u), x = (u) => {
    const l = bn(N(u), { weekStartsOn: +e.weekStart }), r = ia(N(u), { weekStartsOn: +e.weekStart });
    return [l, r];
  }, V = (u, l) => Array.isArray(l) ? l.some((r) => ge(N(M(r)), N(u))) : l(M(JSON.parse(JSON.stringify(u)))), U = (u, l, r) => {
    let p = u ? M(u) : M();
    return (l || l === 0) && (p = Et(p, l)), r && (p = vt(p, r)), p;
  }, O = (u) => Ce(M(), { hours: qe(u), minutes: Xe(u), seconds: pt(u) }), Z = (u) => Ce(M(), {
    hours: +u.hours || 0,
    minutes: +u.minutes || 0,
    seconds: +u.seconds || 0
  }), z = (u, l, r, p) => {
    if (!u)
      return !0;
    if (p) {
      const w = r === "max" ? Pt(u, l) : Ct(u, l), A = { seconds: 0, milliseconds: 0 };
      return w || ht(Ce(u, A), Ce(l, A));
    }
    return r === "max" ? u.getTime() <= l.getTime() : u.getTime() >= l.getTime();
  }, te = () => !e.enableTimePicker || e.monthPicker || e.yearPicker || e.ignoreTimeValidation, re = (u) => Array.isArray(u) ? [u[0] ? O(u[0]) : null, u[1] ? O(u[1]) : null] : O(u), oe = (u) => {
    const l = e.maxTime ? Z(e.maxTime) : M(e.maxDate);
    return Array.isArray(u) ? z(u[0], l, "max", !!e.maxDate) && z(u[1], l, "max", !!e.maxDate) : z(u, l, "max", !!e.maxDate);
  }, ue = (u, l) => {
    const r = e.minTime ? Z(e.minTime) : M(e.minDate);
    return Array.isArray(u) ? z(u[0], r, "min", !!e.minDate) && z(u[1], r, "min", !!e.minDate) && l : z(u, r, "min", !!e.minDate) && l;
  }, de = (u) => {
    let l = !0;
    if (!u || te())
      return !0;
    const r = !e.minDate && !e.maxDate ? re(u) : u;
    return (e.maxTime || e.maxDate) && (l = oe(Ae(r))), (e.minTime || e.minDate) && (l = ue(Ae(r), l)), l;
  }, R = (u, l) => {
    const r = M(JSON.parse(JSON.stringify(u))), p = [];
    for (let w = 0; w < 7; w++) {
      const A = dt(r, w), c = pe(A) !== l;
      p.push({
        text: e.hideOffsetDates && c ? "" : A.getDate(),
        value: A,
        current: !c,
        classData: {}
      });
    }
    return p;
  }, b = (u, l) => {
    const r = [], p = M(N(new Date(l, u))), w = M(N(new Date(l, u + 1, 0))), A = e.weekStart, c = bn(p, { weekStartsOn: A }), S = (f) => {
      const E = R(f, u);
      if (r.push({ days: E }), !r[r.length - 1].days.some(
        (le) => ge(Ke(le.value), Ke(w))
      )) {
        const le = dt(f, 7);
        S(le);
      }
    };
    if (S(c), e.sixWeeks && r.length < 6) {
      const f = 6 - r.length, E = (p.getDay() + 7 - A) % 7, be = 6 - (w.getDay() + 7 - A) % 7, [We, ne] = (() => {
        switch (e.sixWeeks === !0 ? "append" : e.sixWeeks) {
          case "prepend":
            return [!0, !1];
          case "center":
            return [E == 0, !0];
          case "fair":
            return [E == 0 || be > E, !0];
          default:
          case "append":
            return [!1, !1];
        }
      })();
      for (let Le = 1; Le <= f; Le++)
        if (ne ? !!(Le % 2) == We : We) {
          const Me = r[0].days[0], He = R(dt(Me.value, -7), pe(p));
          r.unshift({ days: He });
        } else {
          const Me = r[r.length - 1], He = Me.days[Me.days.length - 1], lt = R(dt(He.value, 1), pe(p));
          r.push({ days: lt });
        }
    }
    return r;
  }, m = (u, l, r) => [Ce(M(u), { date: 1 }), Ce(M(), { month: l, year: r, date: 1 })], B = (u, l) => Oe(...m(e.minDate, u, l)) || ge(...m(e.minDate, u, l)), Y = (u, l) => Ye(...m(e.maxDate, u, l)) || ge(...m(e.maxDate, u, l)), T = (u, l, r) => {
    let p = !1;
    return e.maxDate && r && Y(u, l) && (p = !0), e.minDate && !r && B(u, l) && (p = !0), p;
  };
  return {
    checkPartialRangeValue: n,
    checkRangeEnabled: t,
    getZonedDate: N,
    getZonedToUtc: F,
    formatDate: g,
    getDefaultPattern: v,
    validateDate: W,
    getDefaultStartTime: d,
    isDisabled: $,
    isValidDate: X,
    sanitizeDate: G,
    getWeekFromDate: x,
    matchDate: V,
    setDateMonthOrYear: U,
    isValidTime: de,
    getCalendarDays: b,
    validateMonthYearInRange: (u, l, r, p) => {
      let w = !1;
      return p ? e.minDate && e.maxDate ? w = T(u, l, r) : (e.minDate && B(u, l) || e.maxDate && Y(u, l)) && (w = !0) : w = !0, w;
    },
    validateMaxDate: Y,
    validateMinDate: B,
    assignDefaultTime: _,
    defaults: a,
    hideNavigationButtons: C
  };
}, ke = _t({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), en = H(null), It = H(!1), tn = H(!1), nn = H(!1), an = H(!1), Ie = H(0), _e = H(0), at = () => {
  const e = L(() => It.value ? [...ke.selectionGrid, ke.actionRow].filter((V) => V.length) : tn.value ? [
    ...ke.timePicker[0],
    ...ke.timePicker[1],
    an.value ? [] : [en.value],
    ke.actionRow
  ].filter((V) => V.length) : nn.value ? [...ke.monthPicker, ke.actionRow] : [ke.monthYear, ...ke.calendar, ke.time, ke.actionRow].filter((V) => V.length)), n = (V) => {
    Ie.value = V ? Ie.value + 1 : Ie.value - 1;
    let U = null;
    e.value[_e.value] && (U = e.value[_e.value][Ie.value]), U || (Ie.value = V ? Ie.value - 1 : Ie.value + 1);
  }, a = (V) => {
    if (_e.value === 0 && !V || _e.value === e.value.length && V)
      return;
    _e.value = V ? _e.value + 1 : _e.value - 1, e.value[_e.value] ? e.value[_e.value] && !e.value[_e.value][Ie.value] && Ie.value !== 0 && (Ie.value = e.value[_e.value].length - 1) : _e.value = V ? _e.value - 1 : _e.value + 1;
  }, t = (V) => {
    let U = null;
    e.value[_e.value] && (U = e.value[_e.value][Ie.value]), U ? U.focus({ preventScroll: !It.value }) : Ie.value = V ? Ie.value - 1 : Ie.value + 1;
  }, o = () => {
    n(!0), t(!0);
  }, v = () => {
    n(!1), t(!1);
  }, g = () => {
    a(!1), t(!0);
  }, N = () => {
    a(!0), t(!0);
  }, F = (V, U) => {
    ke[U] = V;
  }, C = (V, U) => {
    ke[U] = V;
  }, W = () => {
    Ie.value = 0, _e.value = 0;
  };
  return {
    buildMatrix: F,
    buildMultiLevelMatrix: C,
    setTimePickerBackRef: (V) => {
      en.value = V;
    },
    setSelectionGrid: (V) => {
      It.value = V, W(), V || (ke.selectionGrid = []);
    },
    setTimePicker: (V, U = !1) => {
      tn.value = V, an.value = U, W(), V || (ke.timePicker[0] = [], ke.timePicker[1] = []);
    },
    setTimePickerElements: (V, U = 0) => {
      ke.timePicker[U] = V;
    },
    arrowRight: o,
    arrowLeft: v,
    arrowUp: g,
    arrowDown: N,
    clearArrowNav: () => {
      ke.monthYear = [], ke.calendar = [], ke.time = [], ke.actionRow = [], ke.selectionGrid = [], ke.timePicker[0] = [], ke.timePicker[1] = [], It.value = !1, tn.value = !1, an.value = !1, nn.value = !1, W(), en.value = null;
    },
    setMonthPicker: (V) => {
      nn.value = V, W();
    },
    refSets: ke
    // exposed for testing
  };
}, Yn = (e) => Array.isArray(e), it = (e) => Array.isArray(e), Vn = (e) => Array.isArray(e) && e.length === 2, rr = (e, n, a, t, o) => {
  const {
    getDefaultStartTime: v,
    isDisabled: g,
    sanitizeDate: N,
    getWeekFromDate: F,
    setDateMonthOrYear: C,
    validateMonthYearInRange: W,
    defaults: _
  } = Ee(e), d = L({
    get: () => e.internalModelValue,
    set: (s) => {
      !e.readonly && !e.disabled && n("update:internal-model-value", s);
    }
  }), $ = H([]);
  nt(d, () => {
    te();
  });
  const X = St(e, "multiCalendars");
  nt(X, () => {
    ye(0);
  });
  const G = H([{ month: pe(M()), year: we(M()) }]), x = _t({
    hours: e.range ? [qe(M()), qe(M())] : qe(M()),
    minutes: e.range ? [Xe(M()), Xe(M())] : Xe(M()),
    seconds: e.range ? [0, 0] : 0
  }), V = L(
    () => (s) => G.value[s] ? G.value[s].month : 0
  ), U = L(
    () => (s) => G.value[s] ? G.value[s].year : 0
  ), O = L(() => e.flow && e.flow.length && !e.partialFlow ? o.value === e.flow.length : !0), Z = (s, D, q) => {
    var ee, h;
    G.value[s] || (G.value[s] = { month: 0, year: 0 }), G.value[s].month = D === null ? (ee = G.value[s]) == null ? void 0 : ee.month : D, G.value[s].year = q === null ? (h = G.value[s]) == null ? void 0 : h.year : q;
  }, z = (s, D) => {
    x[s] = D;
  };
  Ue(() => {
    d.value || (e.startDate && (Z(0, pe(M(e.startDate)), we(M(e.startDate))), _.value.multiCalendars && ye(0)), _.value.startTime && T()), te(!0);
  });
  const te = (s = !1) => {
    if (d.value)
      return Array.isArray(d.value) ? ($.value = d.value, R(s)) : oe(d.value);
    if (e.timePicker)
      return b();
    if (e.monthPicker && !e.range)
      return m();
    if (e.yearPicker && !e.range)
      return B();
    if (_.value.multiCalendars && s && !e.startDate)
      return re(M(), s);
  }, re = (s, D = !1) => {
    if ((!_.value.multiCalendars || !e.multiStatic || D) && Z(0, pe(s), we(s)), _.value.multiCalendars)
      for (let q = 1; q < _.value.multiCalendars; q++) {
        const ee = Ce(M(), { month: V.value(q - 1), year: U.value(q - 1) }), h = Hn(ee, { months: 1 });
        G.value[q] = { month: pe(h), year: we(h) };
      }
  }, oe = (s) => {
    re(s), z("hours", qe(s)), z("minutes", Xe(s)), z("seconds", pt(s));
  }, ue = (s, D) => {
    re(s[0], D);
    const q = (ee, h) => [
      ee(s[0]),
      s[1] ? ee(s[1]) : x[h][1]
    ];
    z("hours", q(qe, "hours")), z("minutes", q(Xe, "minutes")), z("seconds", q(pt, "seconds"));
  }, de = (s, D) => {
    if ((e.range || e.weekPicker) && !e.multiDates)
      return ue(s, D);
    if (e.multiDates) {
      const q = s[s.length - 1];
      return oe(q);
    }
  }, R = (s) => {
    const D = d.value;
    de(D, s), _.value.multiCalendars && e.multiCalendarsSolo && u();
  }, b = () => {
    if (T(), !e.range)
      d.value = Fe(M(), x.hours, x.minutes, Y());
    else {
      const s = x.hours, D = x.minutes;
      d.value = [
        Fe(M(), s[0], D[0], Y()),
        Fe(M(), s[1], D[1], Y(!1))
      ];
    }
  }, m = () => {
    e.multiDates ? d.value = [C(M(), V.value(0), U.value(0))] : d.value = C(M(), V.value(0), U.value(0));
  }, B = () => {
    d.value = M();
  }, Y = (s = !0) => e.enableSeconds ? Array.isArray(x.seconds) ? s ? x.seconds[0] : x.seconds[1] : x.seconds : 0, T = () => {
    const s = v();
    if (s) {
      const D = Array.isArray(s), q = D ? [+s[0].hours, +s[1].hours] : +s.hours, ee = D ? [+s[0].minutes, +s[1].minutes] : +s.minutes, h = D ? [+s[0].seconds, +s[1].seconds] : +s.seconds;
      z("hours", q), z("minutes", ee), e.enableSeconds && z("seconds", h);
    }
  }, y = () => Array.isArray(d.value) && d.value.length ? d.value[d.value.length - 1] : null, u = () => {
    if (Array.isArray(d.value) && d.value.length === 2) {
      const s = M(
        M(d.value[1] ? d.value[1] : ct(d.value[0], 1))
      ), [D, q] = [pe(d.value[0]), we(d.value[0])], [ee, h] = [pe(d.value[1]), we(d.value[1])];
      (D !== ee || D === ee && q !== h) && e.multiCalendarsSolo && Z(1, pe(s), we(s));
    }
  }, l = (s) => {
    const D = ct(s, 1);
    return { month: pe(D), year: we(D) };
  }, r = (s) => {
    const D = pe(M(s)), q = we(M(s));
    if (Z(0, D, q), _.value.multiCalendars > 0)
      for (let ee = 1; ee < _.value.multiCalendars; ee++) {
        const h = l(
          Ce(M(s), { year: V.value(ee - 1), month: U.value(ee - 1) })
        );
        Z(ee, h.month, h.year);
      }
  }, p = (s) => {
    if (d.value && Array.isArray(d.value))
      if (d.value.some((D) => ge(s, D))) {
        const D = d.value.filter((q) => !ge(q, s));
        d.value = D.length ? D : null;
      } else
        (e.multiDatesLimit && +e.multiDatesLimit > d.value.length || !e.multiDatesLimit) && d.value.push(s);
    else
      d.value = [s];
  }, w = (s, D) => {
    const q = Ye(s, D) ? D : s, ee = Ye(D, s) ? D : s;
    return Dn({ start: q, end: ee });
  }, A = (s, D = 0) => {
    if (Array.isArray(d.value) && d.value[D]) {
      const q = ca(s, d.value[D]), ee = w(d.value[D], s), h = ee.length === 1 ? 0 : ee.filter((De) => g(De)).length, j = Math.abs(q) - h;
      if (e.minRange && e.maxRange)
        return j >= +e.minRange && j <= +e.maxRange;
      if (e.minRange)
        return j >= +e.minRange;
      if (e.maxRange)
        return j <= +e.maxRange;
    }
    return !0;
  }, c = (s) => Array.isArray(d.value) && d.value.length === 2 ? e.fixedStart && (Ye(s, d.value[0]) || ge(s, d.value[0])) ? [d.value[0], s] : e.fixedEnd && (Oe(s, d.value[1]) || ge(s, d.value[1])) ? [s, d.value[1]] : (n("invalid-fixed-range", s), d.value) : [], S = () => {
    e.autoApply && O.value && n("auto-apply", e.partialFlow);
  }, f = () => {
    e.autoApply && n("select-date");
  }, E = (s) => !Dn({ start: s[0], end: s[1] }).some((q) => g(q)), le = (s) => (d.value = F(M(s.value)), S()), be = (s) => {
    const D = Fe(M(s.value), x.hours, x.minutes, Y());
    e.multiDates ? p(D) : d.value = D, a(), S();
  }, We = () => {
    $.value = d.value ? d.value.slice() : [], $.value.length === 2 && !(e.fixedStart || e.fixedEnd) && ($.value = []);
  }, ne = (s, D) => {
    const q = [M(s.value), dt(M(s.value), +e.autoRange)];
    E(q) && (D && r(s.value), $.value = q);
  }, Le = (s) => {
    Ge(s.value) || !A(s.value, e.fixedStart ? 0 : 1) || ($.value = c(M(s.value)));
  }, Ge = (s) => e.noDisabledRange ? w($.value[0], s).some((q) => g(q)) : !1, Me = (s, D) => {
    if (We(), e.autoRange)
      return ne(s, D);
    if (e.fixedStart || e.fixedEnd)
      return Le(s);
    $.value[0] ? A(M(s.value)) && !Ge(s.value) && (Oe(M(s.value), M($.value[0])) ? $.value.unshift(M(s.value)) : $.value[1] = M(s.value)) : $.value[0] = M(s.value);
  }, He = (s) => {
    $.value[s] = Fe(
      $.value[s],
      x.hours[s],
      x.minutes[s],
      Y(s !== 1)
    );
  }, lt = () => {
    $.value.length && ($.value[0] && !$.value[1] ? He(0) : (He(0), He(1), a()), d.value = $.value.slice(), $.value[0] && $.value[1] && e.autoApply && n("auto-apply"), $.value[0] && !$.value[1] && e.modelAuto && e.autoApply && n("auto-apply"));
  }, wt = (s, D = !1) => {
    if (!(g(s.value) || !s.current && e.hideOffsetDates)) {
      if (e.weekPicker)
        return le(s);
      if (!e.range)
        return be(s);
      it(x.hours) && it(x.minutes) && !e.multiDates && (Me(s, D), lt());
    }
  }, Q = (s) => {
    const D = s[0];
    return e.weekNumbers === "local" ? ua(D.value, { weekStartsOn: +e.weekStart }) : e.weekNumbers === "iso" ? da(D.value) : typeof e.weekNumbers == "function" ? e.weekNumbers(D.value) : "";
  }, ye = (s) => {
    for (let D = s - 1; D >= 0; D--) {
      const q = Tt(Ce(M(), { month: V.value(D + 1), year: U.value(D + 1) }), 1);
      Z(D, pe(q), we(q));
    }
    for (let D = s + 1; D <= _.value.multiCalendars - 1; D++) {
      const q = ct(Ce(M(), { month: V.value(D - 1), year: U.value(D - 1) }), 1);
      Z(D, pe(q), we(q));
    }
  }, fe = (s) => C(M(), V.value(s), U.value(s)), ot = (s) => Fe(s, x.hours, x.minutes, Y()), st = (s) => {
    p(fe(s));
  }, Ht = (s, D) => {
    const q = e.monthPicker ? V.value(s) !== D.month || !D.fromNav : U.value(s) !== D.year || !D.fromNav;
    if (Z(s, D.month, D.year), _.value.multiCalendars && !e.multiCalendarsSolo && ye(s), e.monthPicker || e.yearPicker)
      if (e.multiDates)
        q && st(s);
      else if (e.range) {
        if (q && A(fe(s))) {
          let ee = d.value ? d.value.slice() : [];
          ee.length === 2 && ee[1] !== null && (ee = []), ee.length ? Oe(fe(s), ee[0]) ? ee.unshift(fe(s)) : ee[1] = fe(s) : ee = [fe(s)], d.value = ee;
        }
      } else
        d.value = fe(s);
    n("update-month-year", { instance: s, month: D.month, year: D.year }), t(e.multiCalendarsSolo ? s : void 0);
  }, xt = async (s = !1) => {
    if (e.autoApply && (e.monthPicker || e.yearPicker)) {
      await Qe();
      const D = e.monthPicker ? s : !1;
      e.range ? n("auto-apply", D || !d.value || d.value.length === 1) : n("auto-apply", D);
    }
    a();
  }, Nt = (s, D) => {
    const q = Ce(M(), { month: V.value(D), year: U.value(D) }), ee = s < 0 ? ct(q, 1) : Tt(q, 1);
    W(pe(ee), we(ee), s < 0, e.preventMinMaxNavigation) && (Z(D, pe(ee), we(ee)), _.value.multiCalendars && !e.multiCalendarsSolo && ye(D), n("update-month-year", { instance: D, month: pe(ee), year: we(ee) }), t());
  }, bt = (s) => {
    Yn(s) && Yn(d.value) && it(x.hours) && it(x.minutes) ? (s[0] && d.value[0] && (d.value[0] = Fe(s[0], x.hours[0], x.minutes[0], Y())), s[1] && d.value[1] && (d.value[1] = Fe(s[1], x.hours[1], x.minutes[1], Y(!1)))) : e.multiDates && Array.isArray(d.value) ? d.value[d.value.length - 1] = ot(s) : !e.range && !Vn(s) && (d.value = ot(s)), n("time-update");
  }, zt = (s, D = !0, q = !1) => {
    const ee = D ? s : x.hours, h = !D && !q ? s : x.minutes, j = q ? s : x.seconds;
    if (e.range && Vn(d.value) && it(ee) && it(h) && it(j) && !e.disableTimeRangeValidation) {
      const De = (xe) => Fe(d.value[xe], ee[xe], h[xe], j[xe]), Te = (xe) => gn(d.value[xe], 0);
      if (ge(d.value[0], d.value[1]) && (Ct(De(0), Te(1)) || Pt(De(1), Te(0))))
        return;
    }
    if (z("hours", ee), z("minutes", h), z("seconds", j), d.value)
      if (e.multiDates) {
        const De = y();
        De && bt(De);
      } else
        bt(d.value);
    else
      e.timePicker && bt(e.range ? [M(), M()] : M());
    a();
  }, Kt = (s, D) => {
    e.monthChangeOnScroll && Nt(e.monthChangeOnScroll !== "inverse" ? -s.deltaY : s.deltaY, D);
  }, jt = (s, D, q = !1) => {
    e.monthChangeOnArrows && e.vertical === q && Rt(s, D);
  }, Rt = (s, D) => {
    Nt(s === "right" ? -1 : 1, D);
  };
  return {
    time: x,
    month: V,
    year: U,
    modelValue: d,
    calendars: G,
    monthYearSelect: xt,
    isDisabled: g,
    updateTime: zt,
    getWeekNum: Q,
    selectDate: wt,
    updateMonthYear: Ht,
    handleScroll: Kt,
    getMarker: (s) => e.markers.find((D) => ge(N(s.value), N(D.date))),
    handleArrow: jt,
    handleSwipe: Rt,
    selectCurrentDate: () => {
      e.range ? d.value && Array.isArray(d.value) && d.value[0] ? d.value = Oe(M(), d.value[0]) ? [M(), d.value[0]] : [d.value[0], M()] : d.value = [M()] : d.value = M(), f();
    },
    presetDateRange: (s, D) => {
      D || s.length && s.length <= 2 && e.range && (d.value = s.map((q) => M(q)), f(), e.multiCalendars && Qe().then(() => te(!0)));
    }
  };
}, lr = (e, n, a) => {
  const t = H(), {
    getZonedToUtc: o,
    getZonedDate: v,
    formatDate: g,
    getDefaultPattern: N,
    checkRangeEnabled: F,
    checkPartialRangeValue: C,
    isValidDate: W,
    setDateMonthOrYear: _,
    defaults: d
  } = Ee(n), $ = H(""), X = St(n, "format");
  nt(t, () => {
    e("internal-model-change", t.value);
  }), nt(X, () => {
    u();
  });
  const G = (f) => {
    const E = f || M();
    return n.modelType ? r(E) : {
      hours: qe(E),
      minutes: Xe(E),
      seconds: n.enableSeconds ? pt(E) : 0
    };
  }, x = (f) => n.modelType ? r(f) : { month: pe(f), year: we(f) }, V = (f) => Array.isArray(f) ? F(() => [
    vt(M(), f[0]),
    f[1] ? vt(M(), f[1]) : C()
  ]) : vt(M(), +f), U = (f, E) => (typeof f == "string" || typeof f == "number") && n.modelType ? l(f) : E, O = (f) => Array.isArray(f) ? [
    U(
      f[0],
      Fe(null, +f[0].hours, +f[0].minutes, f[0].seconds)
    ),
    U(
      f[1],
      Fe(null, +f[1].hours, +f[1].minutes, f[1].seconds)
    )
  ] : U(f, Fe(null, f.hours, f.minutes, f.seconds)), Z = (f) => Array.isArray(f) ? n.multiDates ? f.map((E) => U(E, _(null, +E.month, +E.year))) : F(() => [
    U(f[0], _(null, +f[0].month, +f[0].year)),
    U(
      f[1],
      f[1] ? _(null, +f[1].month, +f[1].year) : C()
    )
  ]) : U(f, _(null, +f.month, +f.year)), z = (f) => {
    if (Array.isArray(f))
      return f.map((E) => l(E));
    throw new Error(Ft.dateArr("multi-dates"));
  }, te = (f) => {
    if (Array.isArray(f))
      return [M(f[0]), M(f[1])];
    throw new Error(Ft.dateArr("week-picker"));
  }, re = (f) => n.modelAuto ? Array.isArray(f) ? [l(f[0]), l(f[1])] : n.autoApply ? [l(f)] : [l(f), null] : Array.isArray(f) ? F(() => [
    l(f[0]),
    f[1] ? l(f[1]) : C()
  ]) : l(f), oe = () => {
    Array.isArray(t.value) && n.range && t.value.length === 1 && t.value.push(C());
  }, ue = () => {
    const f = t.value;
    return [
      r(f[0]),
      f[1] ? r(f[1]) : C()
    ];
  }, de = () => t.value[1] ? ue() : r(Ae(t.value[0])), R = () => (t.value || []).map((f) => r(f)), b = () => (oe(), n.modelAuto ? de() : n.multiDates ? R() : Array.isArray(t.value) ? F(() => ue()) : r(Ae(t.value))), m = (f) => f ? n.timePicker ? O(Ae(f)) : n.monthPicker ? Z(Ae(f)) : n.yearPicker ? V(Ae(f)) : n.multiDates ? z(Ae(f)) : n.weekPicker ? te(Ae(f)) : re(Ae(f)) : null, B = (f) => {
    const E = m(f);
    W(Ae(E)) ? (t.value = Ae(E), u()) : (t.value = null, $.value = "");
  }, Y = () => {
    var E;
    const f = (le) => {
      var be;
      return Mt(le, (be = d.value.textInputOptions) == null ? void 0 : be.format);
    };
    return `${f(t.value[0])} ${(E = d.value.textInputOptions) == null ? void 0 : E.rangeSeparator} ${t.value[1] ? f(t.value[1]) : ""}`;
  }, T = () => {
    var f;
    return a.value && t.value ? Array.isArray(t.value) ? Y() : Mt(t.value, (f = d.value.textInputOptions) == null ? void 0 : f.format) : g(t.value);
  }, y = () => {
    var f;
    return t.value ? n.multiDates ? t.value.map((E) => g(E)).join("; ") : n.textInput && typeof ((f = d.value.textInputOptions) == null ? void 0 : f.format) == "string" ? T() : g(t.value) : "";
  }, u = () => {
    !n.format || typeof n.format == "string" ? $.value = y() : $.value = n.format(t.value);
  }, l = (f) => {
    if (n.utc) {
      const E = new Date(f);
      return n.utc === "preserve" ? new Date(E.getTime() + E.getTimezoneOffset() * 6e4) : E;
    }
    return n.modelType ? n.modelType === "date" || n.modelType === "timestamp" ? v(new Date(f)) : n.modelType === "format" && (typeof n.format == "string" || !n.format) ? on(f, N(), /* @__PURE__ */ new Date()) : v(on(f, n.modelType, /* @__PURE__ */ new Date())) : v(new Date(f));
  }, r = (f) => f ? n.utc ? ha(f, n.utc === "preserve") : n.modelType ? n.modelType === "timestamp" ? +o(f) : n.modelType === "format" && (typeof n.format == "string" || !n.format) ? g(o(f)) : g(o(f), n.modelType) : o(f) : "", p = (f) => {
    e("update:model-value", f);
  }, w = (f) => Array.isArray(t.value) ? n.multiDates ? t.value.map((E) => f(E)) : [
    f(t.value[0]),
    t.value[1] ? f(t.value[1]) : C()
  ] : f(Ae(t.value)), A = (f) => p(Ae(w(f)));
  return {
    inputValue: $,
    internalModelValue: t,
    checkBeforeEmit: () => t.value ? n.range ? n.partialRange ? t.value.length >= 1 : t.value.length === 2 : !!t.value : !1,
    parseExternalModelValue: B,
    formatInputValue: u,
    emitModelValue: () => (u(), n.monthPicker ? A(x) : n.timePicker ? A(G) : n.yearPicker ? A(we) : n.weekPicker ? p(t.value) : p(b()))
  };
}, or = (e, n) => {
  const { validateMonthYearInRange: a, validateMaxDate: t, validateMinDate: o, defaults: v } = Ee(e), g = (_, d) => {
    let $ = _;
    return v.value.filters.months.includes(pe($)) ? ($ = d ? ct(_, 1) : Tt(_, 1), g($, d)) : $;
  }, N = (_, d) => {
    let $ = _;
    return v.value.filters.years.includes(we($)) ? ($ = d ? fa(_, 1) : va(_, 1), N($, d)) : $;
  }, F = (_) => {
    const d = Ce(/* @__PURE__ */ new Date(), { month: e.month, year: e.year });
    let $ = _ ? ct(d, 1) : Tt(d, 1), X = pe($), G = we($);
    v.value.filters.months.includes(X) && ($ = g($, _), X = pe($), G = we($)), v.value.filters.years.includes(G) && ($ = N($, _), G = we($)), a(X, G, _, e.preventMinMaxNavigation) && C(X, G);
  }, C = (_, d) => {
    n("update-month-year", { month: _, year: d });
  }, W = L(() => (_) => {
    if (!e.preventMinMaxNavigation || _ && !e.maxDate || !_ && !e.minDate)
      return !1;
    const d = Ce(/* @__PURE__ */ new Date(), { month: e.month, year: e.year }), $ = _ ? ct(d, 1) : Tt(d, 1), X = [pe($), we($)];
    return _ ? !t(...X) : !o(...X);
  });
  return { handleMonthYearChange: F, isDisabled: W, updateMonthYear: C };
};
var Lt = /* @__PURE__ */ ((e) => (e.center = "center", e.left = "left", e.right = "right", e))(Lt || {});
const sr = (e, n, a, t) => {
  const o = H({
    top: "0",
    left: "0",
    transform: "none",
    opacity: "0"
  }), v = H(!1), g = St(t, "teleportCenter"), N = L(() => v.value ? "-100%" : "0"), F = () => {
    C(), o.value.opacity = "0";
  };
  nt(g, () => {
    U();
  }), Ue(() => {
    C();
  });
  const C = () => {
    const b = $e(n);
    if (b) {
      const { top: m, left: B, width: Y, height: T } = X(b);
      o.value.top = `${m + T / 2}px`, $(B, Y, 50);
    }
  }, W = (b) => {
    if (t.teleport) {
      const m = b.getBoundingClientRect();
      return {
        left: m.left + window.scrollX,
        top: m.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, _ = (b, m) => {
    o.value.left = `${b + m}px`, o.value.transform = `translate(-100%, ${N.value})`;
  }, d = (b) => {
    o.value.left = `${b}px`, o.value.transform = `translate(0, ${N.value})`;
  }, $ = (b, m, B) => {
    t.position === Lt.left && d(b), t.position === Lt.right && _(b, m), t.position === Lt.center && (o.value.left = `${b + m / 2}px`, o.value.transform = B ? `translate(-50%, -${B}%)` : `translate(-50%, ${N.value})`);
  }, X = (b) => {
    const { width: m, height: B } = b.getBoundingClientRect(), { top: Y, left: T } = t.altPosition ? t.altPosition(b) : W(b);
    return { top: +Y, left: +T, width: m, height: B };
  }, G = () => {
    const b = $e(n);
    if (b) {
      const { top: m, left: B, width: Y, height: T } = X(b), y = re();
      o.value.top = `${m + T / 2}px`, $(B, Y, y === "top" ? 100 : 0);
    }
  }, x = () => {
    o.value.left = "50%", o.value.top = "50%", o.value.transform = "translate(-50%, -50%)", o.value.position = "fixed", delete o.value.opacity;
  }, V = () => {
    const b = $e(n), { top: m, left: B, transform: Y } = t.altPosition(b);
    o.value = { top: `${m}px`, left: `${B}px`, transform: Y || "" };
  }, U = (b = !0) => {
    if (!t.inline)
      return g.value ? x() : t.altPosition !== null ? V() : (b && a("recalculate-position"), ue());
  }, O = ({
    inputEl: b,
    menuEl: m,
    left: B,
    width: Y
  }) => {
    window.screen.width > 768 && $(B, Y), te(b, m);
  }, Z = (b, m) => {
    const { top: B, left: Y, height: T, width: y } = X(b);
    o.value.top = `${T + B + +t.offset}px`, v.value = !1, O({ inputEl: b, menuEl: m, left: Y, width: y });
  }, z = (b, m) => {
    const { top: B, left: Y, width: T } = X(b);
    o.value.top = `${B - +t.offset}px`, v.value = !0, O({ inputEl: b, menuEl: m, left: Y, width: T });
  }, te = (b, m) => {
    if (t.autoPosition) {
      const { left: B, width: Y } = X(b), { left: T, right: y } = m.getBoundingClientRect();
      return T <= 0 || T <= B ? d(B) : y >= document.documentElement.clientWidth ? _(B, Y) : $(B, Y);
    }
  }, re = () => {
    const b = $e(e), m = $e(n);
    if (b && m) {
      const { height: B } = b.getBoundingClientRect(), { top: Y, height: T } = m.getBoundingClientRect(), u = window.innerHeight - Y - T, l = Y;
      return B <= u ? "bottom" : B > u && B <= l ? "top" : u >= l ? "bottom" : "top";
    }
    return "bottom";
  }, oe = (b, m) => re() === "bottom" ? Z(b, m) : z(b, m), ue = () => {
    const b = $e(n), m = $e(e);
    if (b && m)
      return t.autoPosition ? oe(b, m) : Z(b, m);
  }, de = function(b) {
    if (b) {
      const m = b.scrollHeight > b.clientHeight, Y = window.getComputedStyle(b).overflowY.indexOf("hidden") !== -1;
      return m && !Y;
    }
    return !0;
  }, R = function(b) {
    return !b || b === document.body || b.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : de(b) ? b : R(b.parentNode);
  };
  return { openOnTop: v, menuStyle: o, resetPosition: F, setMenuPosition: U, setInitialPosition: G, getScrollableParent: R };
}, gt = [
  { name: "clock-icon", use: ["time", "calendar"] },
  { name: "arrow-left", use: ["month-year", "calendar"] },
  { name: "arrow-right", use: ["month-year", "calendar"] },
  { name: "arrow-up", use: ["time", "calendar"] },
  { name: "arrow-down", use: ["time", "calendar"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar"] },
  { name: "day", use: ["calendar"] },
  { name: "month-overlay-value", use: ["calendar", "month-year"] },
  { name: "year-overlay-value", use: ["calendar", "month-year"] },
  { name: "year-overlay", use: ["month-year"] },
  { name: "month-overlay", use: ["month-year"] },
  { name: "month-overlay-header", use: ["month-year"] },
  { name: "year-overlay-header", use: ["month-year"] },
  { name: "hours-overlay-value", use: ["calendar", "time"] },
  { name: "minutes-overlay-value", use: ["calendar", "time"] },
  { name: "seconds-overlay-value", use: ["calendar", "time"] },
  { name: "hours", use: ["calendar", "time"] },
  { name: "minutes", use: ["calendar", "time"] },
  { name: "month", use: ["calendar", "month-year"] },
  { name: "year", use: ["calendar", "month-year"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar"] },
  { name: "marker-tooltip", use: ["calendar"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time"] },
  { name: "am-pm-button", use: ["calendar", "time"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year"] },
  { name: "time-picker", use: ["menu"] },
  { name: "action-row", use: ["action"] }
], ir = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], ur = {
  all: () => gt,
  monthYear: () => gt.filter((e) => e.use.includes("month-year")),
  input: () => ir,
  timePicker: () => gt.filter((e) => e.use.includes("time")),
  action: () => gt.filter((e) => e.use.includes("action")),
  calendar: () => gt.filter((e) => e.use.includes("calendar")),
  menu: () => gt.filter((e) => e.use.includes("menu"))
}, ft = (e, n, a) => {
  const t = [];
  return ur[n]().forEach((o) => {
    e[o.name] && t.push(o.name);
  }), a && a.length && a.forEach((o) => {
    o.slot && t.push(o.slot);
  }), t;
}, Wt = (e) => ({ transitionName: L(() => (a) => e && typeof e != "boolean" ? a ? e.open : e.close : ""), showTransition: !!e }), rt = {
  multiCalendars: { type: [Boolean, Number, String], default: null },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  closeOnScroll: { type: Boolean, default: !1 },
  autoPosition: { type: Boolean, default: !0 },
  closeOnAutoApply: { type: Boolean, default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: String, default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  menuClassName: { type: String, default: null },
  dayClass: { type: Function, default: null },
  yearRange: { type: Array, default: () => [1900, 2100] },
  multiCalendarsSolo: { type: Boolean, default: !1 },
  calendarCellClassName: { type: String, default: null },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  autoRange: { type: [Number, String], default: null },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: () => [] },
  showNowButton: { type: Boolean, default: !1 },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  modeHeight: { type: [Number, String], default: 255 },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetRanges: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  minRange: { type: [Number, String], default: null },
  maxRange: { type: [Number, String], default: null },
  multiDatesLimit: { type: [Number, String], default: null },
  reverseYears: { type: Boolean, default: !1 },
  keepActionRow: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  multiStatic: { type: Boolean, default: !0 },
  disableTimeRangeValidation: { type: Boolean, default: !1 },
  highlight: {
    type: [Array, Function],
    default: null
  },
  highlightWeekDays: {
    type: Array,
    default: null
  },
  highlightDisabledDays: { type: Boolean, default: !1 },
  teleport: { type: [String, Boolean], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function],
    default: null
  },
  calendarClassName: { type: String, default: null },
  noSwipe: { type: Boolean, default: !1 },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: Boolean, default: !1 },
  partialRange: { type: Boolean, default: !0 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  inputClassName: { type: String, default: null },
  inlineWithInput: { type: Boolean, default: !1 },
  textInputOptions: { type: Object, default: () => null },
  fixedStart: { type: Boolean, default: !1 },
  fixedEnd: { type: Boolean, default: !1 },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: Boolean, default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: Boolean, default: !1 },
  textInput: { type: Boolean, default: !1 },
  onClickOutside: { type: Function, default: null },
  noDisabledRange: { type: Boolean, default: !1 },
  sixWeeks: { type: [Boolean, String], default: !1 },
  actionRow: { type: Object, default: () => ({}) },
  allowPreventDefault: { type: Boolean, default: !1 }
}, dr = {
  key: 1,
  class: "dp__input_wrap"
}, cr = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "onKeydown"], fr = {
  key: 2,
  class: "dp__input_icon"
}, vr = {
  key: 4,
  class: "dp__clear_icon"
}, mr = /* @__PURE__ */ je({
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...rt
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur"
  ],
  setup(e, { expose: n, emit: a }) {
    const t = e, { getDefaultPattern: o, isValidDate: v, defaults: g, getDefaultStartTime: N, assignDefaultTime: F } = Ee(t), C = H(), W = H(null), _ = H(!1), d = H(!1), $ = L(
      () => ({
        dp__pointer: !t.disabled && !t.readonly && !t.textInput,
        dp__disabled: t.disabled,
        dp__input_readonly: !t.textInput,
        dp__input: !0,
        dp__input_icon_pad: !t.hideInputIcon,
        dp__input_valid: t.state,
        dp__input_invalid: t.state === !1,
        dp__input_focus: _.value || t.isMenuOpen,
        dp__input_reg: !t.textInput,
        [t.inputClassName]: !!t.inputClassName
      })
    ), X = () => {
      a("set-input-date", null), t.autoApply && (a("set-empty-date"), C.value = null);
    }, G = (m) => {
      var Y;
      const B = N();
      return ga(
        m,
        ((Y = g.value.textInputOptions) == null ? void 0 : Y.format) || o(),
        B || F({}),
        t.inputValue,
        d.value
      );
    }, x = (m) => {
      const { rangeSeparator: B } = g.value.textInputOptions, [Y, T] = m.split(`${B}`);
      if (Y) {
        const y = G(Y.trim()), u = T ? G(T.trim()) : null, l = y && u ? [y, u] : [y];
        C.value = y ? l : null;
      }
    }, V = () => {
      d.value = !0;
    }, U = (m) => {
      if (t.range)
        x(m);
      else if (t.multiDates) {
        const B = m.split(";");
        C.value = B.map((Y) => G(Y.trim())).filter((Y) => Y);
      } else
        C.value = G(m);
    }, O = (m) => {
      var Y;
      const { value: B } = m.target;
      B !== "" ? ((Y = g.value.textInputOptions) != null && Y.openMenu && !t.isMenuOpen && a("open"), U(B), a("set-input-date", C.value)) : X(), d.value = !1, a("update:input-value", B);
    }, Z = () => {
      var m, B;
      (m = g.value.textInputOptions) != null && m.enterSubmit && v(C.value) && t.inputValue !== "" ? (a("set-input-date", C.value, !0), C.value = null) : (B = g.value.textInputOptions) != null && B.enterSubmit && t.inputValue === "" && (C.value = null, a("clear"));
    }, z = () => {
      var m, B;
      (m = g.value.textInputOptions) != null && m.tabSubmit && v(C.value) && t.inputValue !== "" ? (a("set-input-date", C.value, !0), C.value = null) : (B = g.value.textInputOptions) != null && B.tabSubmit && t.inputValue === "" && (C.value = null, a("clear"));
    }, te = () => {
      _.value = !0, a("focus");
    }, re = (m) => {
      var B;
      m.preventDefault(), m.stopImmediatePropagation(), m.stopPropagation(), t.textInput && ((B = g.value.textInputOptions) != null && B.openMenu) && !t.inlineWithInput ? t.isMenuOpen ? g.value.textInputOptions.enterSubmit && a("select-date") : a("open") : t.textInput || a("toggle");
    }, oe = () => {
      _.value = !1, t.isMenuOpen || a("blur"), t.autoApply && t.textInput && C.value && (a("set-input-date", C.value), a("select-date"), C.value = null);
    }, ue = () => {
      a("clear");
    }, de = (m) => {
      if (!t.textInput) {
        if (m.code === "Tab")
          return;
        m.preventDefault();
      }
    };
    return n({
      focusInput: () => {
        W.value && W.value.focus({ preventScroll: !0 });
      },
      setParsedDate: (m) => {
        C.value = m;
      }
    }), (m, B) => {
      var Y;
      return k(), I("div", { onClick: re }, [
        m.$slots.trigger && !m.$slots["dp-input"] && !m.inline ? K(m.$slots, "trigger", { key: 0 }) : P("", !0),
        !m.$slots.trigger && (!m.inline || m.inlineWithInput) ? (k(), I("div", dr, [
          m.$slots["dp-input"] && !m.$slots.trigger && !m.inline ? K(m.$slots, "dp-input", {
            key: 0,
            value: e.inputValue,
            onInput: O,
            onEnter: Z,
            onTab: z,
            onClear: ue,
            onBlur: oe,
            onKeypress: de,
            onPaste: V
          }) : P("", !0),
          m.$slots["dp-input"] ? P("", !0) : (k(), I("input", {
            key: 1,
            ref_key: "inputRef",
            ref: W,
            id: m.uid ? `dp-input-${m.uid}` : void 0,
            name: m.name,
            class: he(i($)),
            inputmode: m.textInput ? "text" : "none",
            placeholder: m.placeholder,
            disabled: m.disabled,
            readonly: m.readonly,
            required: m.required,
            value: e.inputValue,
            autocomplete: m.autocomplete,
            "aria-label": (Y = i(g).ariaLabels) == null ? void 0 : Y.input,
            onInput: O,
            onKeydown: [
              ie(re, ["enter"]),
              ie(z, ["tab"]),
              de
            ],
            onBlur: oe,
            onFocus: te,
            onKeypress: de,
            onPaste: V
          }, null, 42, cr)),
          m.$slots["input-icon"] && !m.hideInputIcon ? (k(), I("span", fr, [
            K(m.$slots, "input-icon")
          ])) : P("", !0),
          !m.$slots["input-icon"] && !m.hideInputIcon && !m.$slots["dp-input"] ? (k(), ve(i(Ut), {
            key: 3,
            class: "dp__input_icon dp__input_icons"
          })) : P("", !0),
          m.$slots["clear-icon"] && e.inputValue && m.clearable && !m.disabled && !m.readonly ? (k(), I("span", vr, [
            K(m.$slots, "clear-icon", { clear: ue })
          ])) : P("", !0),
          m.clearable && !m.$slots["clear-icon"] && e.inputValue && !m.disabled && !m.readonly ? (k(), ve(i(ya), {
            key: 5,
            class: "dp__clear_icon dp__input_icons",
            onClick: Je(ue, ["stop", "prevent"])
          }, null, 8, ["onClick"])) : P("", !0)
        ])) : P("", !0)
      ]);
    };
  }
}), yr = ["title"], gr = { class: "dp__action_buttons" }, hr = ["onKeydown", "disabled"], pr = /* @__PURE__ */ je({
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    calendarWidth: { type: Number, default: 0 },
    ...rt
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(e, { emit: n }) {
    const a = e, { formatDate: t, isValidTime: o, defaults: v } = Ee(a), { buildMatrix: g } = at(), N = H(null), F = H(null);
    Ue(() => {
      a.arrowNavigation && g([$e(N), $e(F)], "actionRow");
    });
    const C = L(() => a.range && !a.partialRange && a.internalModelValue ? a.internalModelValue.length === 2 : !0), W = L(() => !_.value || !d.value || !C.value), _ = L(() => !a.enableTimePicker || a.ignoreTimeValidation ? !0 : o(a.internalModelValue)), d = L(() => a.monthPicker ? a.range && Array.isArray(a.internalModelValue) ? !a.internalModelValue.filter((Z) => !V(Z)).length : V(a.internalModelValue) : !0), $ = () => {
      const O = v.value.previewFormat;
      return a.timePicker || a.monthPicker, O(Ae(a.internalModelValue));
    }, X = () => {
      const O = a.internalModelValue;
      return v.value.multiCalendars > 0 ? `${t(O[0])} - ${t(O[1])}` : [t(O[0]), t(O[1])];
    }, G = L(() => !a.internalModelValue || !a.menuMount ? "" : typeof v.value.previewFormat == "string" ? Array.isArray(a.internalModelValue) ? a.internalModelValue.length === 2 && a.internalModelValue[1] ? X() : a.multiDates ? a.internalModelValue.map((O) => `${t(O)}`) : a.modelAuto ? `${t(a.internalModelValue[0])}` : `${t(a.internalModelValue[0])} -` : t(a.internalModelValue) : $()), x = L(
      () => Array.isArray(G.value) ? G.value.join(a.multiDates ? "; " : " - ") : G.value
    ), V = (O) => {
      if (!a.monthPicker)
        return !0;
      let Z = !0;
      const z = M(Dt(O));
      if (a.minDate && a.maxDate) {
        const te = M(Dt(a.minDate)), re = M(Dt(a.maxDate));
        return Ye(z, te) && Oe(z, re) || ge(z, te) || ge(z, re);
      }
      if (a.minDate) {
        const te = M(Dt(a.minDate));
        Z = Ye(z, te) || ge(z, te);
      }
      if (a.maxDate) {
        const te = M(Dt(a.maxDate));
        Z = Oe(z, te) || ge(z, te);
      }
      return Z;
    }, U = () => {
      _.value && d.value && C.value ? n("select-date") : n("invalid-select");
    };
    return (O, Z) => (k(), I("div", {
      class: "dp__action_row",
      style: et(e.calendarWidth ? { width: `${e.calendarWidth}px` } : {})
    }, [
      O.$slots["action-row"] ? K(O.$slots, "action-row", Ne(Se({ key: 0 }, {
        internalModelValue: e.internalModelValue,
        disabled: i(W),
        selectDate: () => O.$emit("select-date"),
        closePicker: () => O.$emit("close-picker")
      }))) : (k(), I(me, { key: 1 }, [
        i(v).actionRow.showPreview ? (k(), I("div", {
          key: 0,
          class: "dp__selection_preview",
          title: i(x)
        }, [
          O.$slots["action-preview"] ? K(O.$slots, "action-preview", {
            key: 0,
            value: e.internalModelValue
          }) : P("", !0),
          O.$slots["action-preview"] ? P("", !0) : (k(), I(me, { key: 1 }, [
            Ze(Re(i(x)), 1)
          ], 64))
        ], 8, yr)) : P("", !0),
        ae("div", gr, [
          O.$slots["action-buttons"] ? K(O.$slots, "action-buttons", {
            key: 0,
            value: e.internalModelValue
          }) : P("", !0),
          O.$slots["action-buttons"] ? P("", !0) : (k(), I(me, { key: 1 }, [
            !O.inline && i(v).actionRow.showCancel ? (k(), I("button", {
              key: 0,
              ref_key: "cancelButtonRef",
              ref: N,
              class: "dp__action_button dp__action_cancel",
              onClick: Z[0] || (Z[0] = (z) => O.$emit("close-picker")),
              onKeydown: [
                Z[1] || (Z[1] = ie((z) => O.$emit("close-picker"), ["enter"])),
                Z[2] || (Z[2] = ie((z) => O.$emit("close-picker"), ["space"]))
              ]
            }, Re(O.cancelText), 545)) : P("", !0),
            O.showNowButton || i(v).actionRow.showNow ? (k(), I("button", {
              key: 1,
              ref_key: "cancelButtonRef",
              ref: N,
              class: "dp__action_button dp__action_cancel",
              onClick: Z[3] || (Z[3] = (z) => O.$emit("select-now")),
              onKeydown: [
                Z[4] || (Z[4] = ie((z) => O.$emit("select-now"), ["enter"])),
                Z[5] || (Z[5] = ie((z) => O.$emit("select-now"), ["space"]))
              ]
            }, Re(O.nowButtonLabel), 545)) : P("", !0),
            i(v).actionRow.showSelect ? (k(), I("button", {
              key: 2,
              class: "dp__action_button dp__action_select",
              onKeydown: [
                ie(U, ["enter"]),
                ie(U, ["space"])
              ],
              onClick: U,
              disabled: i(W),
              ref_key: "selectButtonRef",
              ref: F
            }, Re(O.selectText), 41, hr)) : P("", !0)
          ], 64))
        ])
      ], 64))
    ], 4));
  }
}), kr = ["aria-label"], wr = {
  class: "dp__calendar_header",
  role: "row"
}, br = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, Dr = /* @__PURE__ */ ae("div", { class: "dp__calendar_header_separator" }, null, -1), $r = ["aria-label"], Mr = {
  key: 0,
  role: "gridcell",
  class: "dp__calendar_item dp__week_num"
}, Tr = { class: "dp__cell_inner" }, Ar = ["aria-selected", "aria-disabled", "aria-label", "onClick", "onKeydown", "onMouseenter", "onMouseleave"], Sr = /* @__PURE__ */ je({
  __name: "Calendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    getWeekNum: {
      type: Function,
      default: () => ""
    },
    specificMode: { type: Boolean, default: !1 },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...rt
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(e, { expose: n, emit: a }) {
    const t = e, { buildMultiLevelMatrix: o } = at(), { setDateMonthOrYear: v, defaults: g } = Ee(t), N = H(null), F = H({
      bottom: "",
      left: "",
      transform: ""
    }), C = H([]), W = H(null), _ = H(!0), d = H(""), $ = H({ startX: 0, endX: 0, startY: 0, endY: 0 }), X = H([]), G = H({ left: "50%" }), x = L(() => t.dayNames ? Array.isArray(t.dayNames) ? t.dayNames : t.dayNames(t.locale, +t.weekStart) : Ka(t.locale, +t.weekStart));
    Ue(() => {
      a("mount", { cmp: "calendar", refs: C }), t.noSwipe || W.value && (W.value.addEventListener("touchstart", R, { passive: !1 }), W.value.addEventListener("touchend", b, { passive: !1 }), W.value.addEventListener("touchmove", m, { passive: !1 })), t.monthChangeOnScroll && W.value && W.value.addEventListener("wheel", T, { passive: !1 });
    });
    const V = (y) => y ? t.vertical ? "vNext" : "next" : t.vertical ? "vPrevious" : "previous", U = (y, u) => {
      if (t.transitions) {
        const l = Ke(v(M(), t.month, t.year));
        d.value = Ye(Ke(v(M(), y, u)), l) ? g.value.transitions[V(!0)] : g.value.transitions[V(!1)], _.value = !1, Qe(() => {
          _.value = !0;
        });
      }
    }, O = L(
      () => ({
        [t.calendarClassName]: !!t.calendarClassName
      })
    ), Z = L(() => (y) => {
      const u = qa(y);
      return {
        dp__marker_dot: u.type === "dot",
        dp__marker_line: u.type === "line"
      };
    }), z = L(() => (y) => ge(y, N.value)), te = L(() => ({
      dp__calendar: !0,
      dp__calendar_next: g.value.multiCalendars > 0 && t.instance !== 0
    })), re = L(() => (y) => t.hideOffsetDates ? y.current : !0), oe = L(() => t.specificMode ? { height: `${t.modeHeight}px` } : void 0), ue = async (y, u, l) => {
      var r, p;
      if (a("set-hover-date", y), (p = (r = y.marker) == null ? void 0 : r.tooltip) != null && p.length) {
        const w = $e(C.value[u][l]);
        if (w) {
          const { width: A, height: c } = w.getBoundingClientRect();
          N.value = y.value;
          let S = { left: `${A / 2}px` }, f = -50;
          if (await Qe(), X.value[0]) {
            const { left: E, width: le } = X.value[0].getBoundingClientRect();
            E < 0 && (S = { left: "0" }, f = 0, G.value.left = `${A / 2}px`), window.innerWidth < E + le && (S = { right: "0" }, f = 0, G.value.left = `${le - A / 2}px`);
          }
          F.value = {
            bottom: `${c}px`,
            ...S,
            transform: `translateX(${f}%)`
          }, a("tooltip-open", y.marker);
        }
      }
    }, de = (y) => {
      N.value && (N.value = null, F.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), a("tooltip-close", y.marker));
    }, R = (y) => {
      $.value.startX = y.changedTouches[0].screenX, $.value.startY = y.changedTouches[0].screenY;
    }, b = (y) => {
      $.value.endX = y.changedTouches[0].screenX, $.value.endY = y.changedTouches[0].screenY, B();
    }, m = (y) => {
      t.vertical && !t.inline && y.preventDefault();
    }, B = () => {
      const y = t.vertical ? "Y" : "X";
      Math.abs($.value[`start${y}`] - $.value[`end${y}`]) > 10 && a("handle-swipe", $.value[`start${y}`] > $.value[`end${y}`] ? "right" : "left");
    }, Y = (y, u, l) => {
      y && (Array.isArray(C.value[u]) ? C.value[u][l] = y : C.value[u] = [y]), t.arrowNavigation && o(C.value, "calendar");
    }, T = (y) => {
      t.monthChangeOnScroll && (y.preventDefault(), a("handle-scroll", y));
    };
    return n({ triggerTransition: U }), (y, u) => {
      var l;
      return k(), I("div", {
        class: he(i(te))
      }, [
        ae("div", {
          style: et(i(oe)),
          ref_key: "calendarWrapRef",
          ref: W,
          role: "grid",
          class: he(i(O)),
          "aria-label": (l = i(g).ariaLabels) == null ? void 0 : l.calendarWrap
        }, [
          e.specificMode ? P("", !0) : (k(), I(me, { key: 0 }, [
            ae("div", wr, [
              y.weekNumbers ? (k(), I("div", br, Re(y.weekNumName), 1)) : P("", !0),
              (k(!0), I(me, null, Pe(i(x), (r, p) => (k(), I("div", {
                class: "dp__calendar_header_item",
                role: "gridcell",
                key: p
              }, [
                y.$slots["calendar-header"] ? K(y.$slots, "calendar-header", {
                  key: 0,
                  day: r,
                  index: p
                }) : P("", !0),
                y.$slots["calendar-header"] ? P("", !0) : (k(), I(me, { key: 1 }, [
                  Ze(Re(r), 1)
                ], 64))
              ]))), 128))
            ]),
            Dr,
            tt(kt, {
              name: d.value,
              css: !!y.transitions
            }, {
              default: se(() => {
                var r;
                return [
                  _.value ? (k(), I("div", {
                    key: 0,
                    class: "dp__calendar",
                    role: "grid",
                    "aria-label": (r = i(g).ariaLabels) == null ? void 0 : r.calendarDays
                  }, [
                    (k(!0), I(me, null, Pe(e.mappedDates, (p, w) => (k(), I("div", {
                      class: "dp__calendar_row",
                      role: "row",
                      key: w
                    }, [
                      y.weekNumbers ? (k(), I("div", Mr, [
                        ae("div", Tr, Re(e.getWeekNum(p.days)), 1)
                      ])) : P("", !0),
                      (k(!0), I(me, null, Pe(p.days, (A, c) => {
                        var S, f, E;
                        return k(), I("div", {
                          role: "gridcell",
                          class: "dp__calendar_item",
                          ref_for: !0,
                          ref: (le) => Y(le, w, c),
                          key: c + w,
                          "aria-selected": A.classData.dp__active_date || A.classData.dp__range_start || A.classData.dp__range_start,
                          "aria-disabled": A.classData.dp__cell_disabled,
                          "aria-label": (f = (S = i(g).ariaLabels) == null ? void 0 : S.day) == null ? void 0 : f.call(S, A),
                          tabindex: "0",
                          onClick: Je((le) => y.$emit("select-date", A), ["stop", "prevent"]),
                          onKeydown: [
                            ie((le) => y.$emit("select-date", A), ["enter"]),
                            ie((le) => y.$emit("handle-space", A), ["space"])
                          ],
                          onMouseenter: (le) => ue(A, w, c),
                          onMouseleave: (le) => de(A)
                        }, [
                          ae("div", {
                            class: he(["dp__cell_inner", A.classData])
                          }, [
                            y.$slots.day && i(re)(A) ? K(y.$slots, "day", {
                              key: 0,
                              day: +A.text,
                              date: A.value
                            }) : P("", !0),
                            y.$slots.day ? P("", !0) : (k(), I(me, { key: 1 }, [
                              Ze(Re(A.text), 1)
                            ], 64)),
                            A.marker && i(re)(A) ? (k(), I("div", {
                              key: 2,
                              class: he(i(Z)(A.marker)),
                              style: et(A.marker.color ? { backgroundColor: A.marker.color } : {})
                            }, null, 6)) : P("", !0),
                            i(z)(A.value) ? (k(), I("div", {
                              key: 3,
                              class: "dp__marker_tooltip",
                              ref_for: !0,
                              ref_key: "activeTooltip",
                              ref: X,
                              style: et(F.value)
                            }, [
                              (E = A.marker) != null && E.tooltip ? (k(), I("div", {
                                key: 0,
                                class: "dp__tooltip_content",
                                onClick: u[0] || (u[0] = Je(() => {
                                }, ["stop"]))
                              }, [
                                (k(!0), I(me, null, Pe(A.marker.tooltip, (le, be) => (k(), I("div", {
                                  key: be,
                                  class: "dp__tooltip_text"
                                }, [
                                  y.$slots["marker-tooltip"] ? K(y.$slots, "marker-tooltip", {
                                    key: 0,
                                    tooltip: le,
                                    day: A.value
                                  }) : P("", !0),
                                  y.$slots["marker-tooltip"] ? P("", !0) : (k(), I(me, { key: 1 }, [
                                    ae("div", {
                                      class: "dp__tooltip_mark",
                                      style: et(le.color ? { backgroundColor: le.color } : {})
                                    }, null, 4),
                                    ae("div", null, Re(le.text), 1)
                                  ], 64))
                                ]))), 128)),
                                ae("div", {
                                  class: "dp__arrow_bottom_tp",
                                  style: et(G.value)
                                }, null, 4)
                              ])) : P("", !0)
                            ], 4)) : P("", !0)
                          ], 2)
                        ], 40, Ar);
                      }), 128))
                    ]))), 128))
                  ], 8, $r)) : P("", !0)
                ];
              }),
              _: 3
            }, 8, ["name", "css"])
          ], 64))
        ], 14, kr)
      ], 2);
    };
  }
}), Pr = ["aria-label", "aria-disabled"], rn = /* @__PURE__ */ je({
  __name: "ActionIcon",
  props: {
    ariaLabel: null,
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(e, { emit: n }) {
    const a = H(null);
    return Ue(() => n("set-ref", a)), (t, o) => (k(), I("button", {
      class: "dp__btn dp__month_year_col_nav",
      onClick: o[0] || (o[0] = (v) => t.$emit("activate")),
      onKeydown: [
        o[1] || (o[1] = ie((v) => t.$emit("activate"), ["enter"])),
        o[2] || (o[2] = ie((v) => t.$emit("activate"), ["space"]))
      ],
      tabindex: "0",
      role: "button",
      "aria-label": e.ariaLabel,
      "aria-disabled": e.disabled,
      ref_key: "elRef",
      ref: a
    }, [
      ae("span", {
        class: he(["dp__inner_nav", { dp__inner_nav_disabled: e.disabled }])
      }, [
        K(t.$slots, "default")
      ], 2)
    ], 40, Pr));
  }
}), Cr = ["onKeydown"], _r = { class: "dp__selection_grid_header" }, Nr = ["aria-selected", "aria-disabled", "onClick", "onKeydown", "onMouseover"], Rr = ["aria-label", "onKeydown"], At = /* @__PURE__ */ je({
  __name: "SelectionGrid",
  props: {
    items: { type: Array, default: () => [] },
    modelValue: { type: [String, Number], default: null },
    multiModelValue: { type: Array, default: () => [] },
    disabledValues: { type: Array, default: () => [] },
    minValue: { type: [Number, String], default: null },
    maxValue: { type: [Number, String], default: null },
    year: { type: Number, default: 0 },
    skipActive: { type: Boolean, default: !1 },
    headerRefs: { type: Array, default: () => [] },
    skipButtonRef: { type: Boolean, default: !1 },
    monthPicker: { type: Boolean, default: !1 },
    yearPicker: { type: Boolean, default: !1 },
    escClose: { type: Boolean, default: !0 },
    type: { type: String, default: null },
    arrowNavigation: { type: Boolean, default: !1 },
    autoApply: { type: Boolean, default: !1 },
    textInput: { type: Boolean, default: !1 },
    ariaLabels: { type: Object, default: () => ({}) },
    hideNavigation: { type: Array, default: () => [] }
  },
  emits: ["update:model-value", "selected", "toggle", "reset-flow"],
  setup(e, { expose: n, emit: a }) {
    const t = e, { setSelectionGrid: o, buildMultiLevelMatrix: v, setMonthPicker: g } = at(), { hideNavigationButtons: N } = Ee(t), F = H(!1), C = H(null), W = H(null), _ = H([]), d = H(), $ = H(null), X = H(0), G = H(null);
    ta(() => {
      C.value = null;
    }), Ue(() => {
      Qe().then(() => ue()), V(), x(!0);
    }), mn(() => x(!1));
    const x = (T) => {
      var y;
      t.arrowNavigation && ((y = t.headerRefs) != null && y.length ? g(T) : o(T));
    }, V = () => {
      const T = $e(W);
      T && (t.textInput || T.focus({ preventScroll: !0 }), F.value = T.clientHeight < T.scrollHeight);
    }, U = L(
      () => ({
        dp__overlay: !0
      })
    ), O = L(() => ({
      dp__overlay_col: !0
    })), Z = (T) => t.skipActive ? !1 : T.value === t.modelValue, z = L(() => t.items.map((T) => T.filter((y) => y).map((y) => {
      var r, p, w;
      const u = t.disabledValues.some((A) => A === y.value) || oe(y.value), l = (r = t.multiModelValue) != null && r.length ? (p = t.multiModelValue) == null ? void 0 : p.some(
        (A) => ge(
          A,
          vt(
            t.monthPicker ? Et(/* @__PURE__ */ new Date(), y.value) : /* @__PURE__ */ new Date(),
            t.monthPicker ? t.year : y.value
          )
        )
      ) : Z(y);
      return {
        ...y,
        className: {
          dp__overlay_cell_active: l,
          dp__overlay_cell: !l,
          dp__overlay_cell_disabled: u,
          dp__overlay_cell_active_disabled: u && l,
          dp__overlay_cell_pad: !0,
          dp__cell_in_between: (w = t.multiModelValue) != null && w.length && t.skipActive ? R(y.value) : !1
        }
      };
    }))), te = L(
      () => ({
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: F.value,
        dp__button_bottom: t.autoApply
      })
    ), re = L(() => {
      var T, y;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((T = t.items) == null ? void 0 : T.length) <= 6,
        dp__container_block: ((y = t.items) == null ? void 0 : y.length) > 6
      };
    }), oe = (T) => {
      const y = t.maxValue || t.maxValue === 0, u = t.minValue || t.minValue === 0;
      return !y && !u ? !1 : y && u ? +T > +t.maxValue || +T < +t.minValue : y ? +T > +t.maxValue : u ? +T < +t.minValue : !1;
    }, ue = () => {
      const T = $e(C), y = $e(W), u = $e($), l = $e(G), r = u ? u.getBoundingClientRect().height : 0;
      y && (X.value = y.getBoundingClientRect().height - r), T && l && (l.scrollTop = T.offsetTop - l.offsetTop - (X.value / 2 - T.getBoundingClientRect().height) - r);
    }, de = (T) => {
      !t.disabledValues.some((y) => y === T) && !oe(T) && (a("update:model-value", T), a("selected"));
    }, R = (T) => {
      const y = t.monthPicker ? t.year : T;
      return jn(
        t.multiModelValue,
        vt(
          t.monthPicker ? Et(/* @__PURE__ */ new Date(), d.value || 0) : /* @__PURE__ */ new Date(),
          t.monthPicker ? y : d.value || y
        ),
        vt(t.monthPicker ? Et(/* @__PURE__ */ new Date(), T) : /* @__PURE__ */ new Date(), y)
      );
    }, b = () => {
      a("toggle"), a("reset-flow");
    }, m = () => {
      t.escClose && b();
    }, B = (T, y, u, l) => {
      T && (y.value === +t.modelValue && !t.disabledValues.includes(y.value) && (C.value = T), t.arrowNavigation && (Array.isArray(_.value[u]) ? _.value[u][l] = T : _.value[u] = [T], Y()));
    }, Y = () => {
      var y, u;
      const T = (y = t.headerRefs) != null && y.length ? [t.headerRefs].concat(_.value) : _.value.concat([t.skipButtonRef ? [] : [$.value]]);
      v(Ae(T), (u = t.headerRefs) != null && u.length ? "monthPicker" : "selectionGrid");
    };
    return n({ focusGrid: V }), (T, y) => {
      var u;
      return k(), I("div", {
        ref_key: "gridWrapRef",
        ref: W,
        class: he(i(U)),
        role: "dialog",
        tabindex: "0",
        onKeydown: ie(m, ["esc"])
      }, [
        ae("div", {
          class: he(i(re)),
          ref_key: "containerRef",
          ref: G,
          role: "grid",
          style: et({ height: `${X.value}px` })
        }, [
          ae("div", _r, [
            K(T.$slots, "header")
          ]),
          T.$slots.overlay ? K(T.$slots, "overlay", { key: 0 }) : (k(!0), I(me, { key: 1 }, Pe(i(z), (l, r) => (k(), I("div", {
            class: he(["dp__overlay_row", { dp__flex_row: i(z).length >= 3 }]),
            key: r,
            role: "row"
          }, [
            (k(!0), I(me, null, Pe(l, (p, w) => (k(), I("div", {
              role: "gridcell",
              class: he(i(O)),
              key: p.value,
              "aria-selected": p.value === e.modelValue && !e.disabledValues.includes(p.value),
              "aria-disabled": p.className.dp__overlay_cell_disabled,
              ref_for: !0,
              ref: (A) => B(A, p, r, w),
              tabindex: "0",
              onClick: (A) => de(p.value),
              onKeydown: [
                ie((A) => de(p.value), ["enter"]),
                ie((A) => de(p.value), ["space"])
              ],
              onMouseover: (A) => d.value = p.value
            }, [
              ae("div", {
                class: he(p.className)
              }, [
                T.$slots.item ? K(T.$slots, "item", {
                  key: 0,
                  item: p
                }) : P("", !0),
                T.$slots.item ? P("", !0) : (k(), I(me, { key: 1 }, [
                  Ze(Re(p.text), 1)
                ], 64))
              ], 2)
            ], 42, Nr))), 128))
          ], 2))), 128))
        ], 6),
        T.$slots["button-icon"] ? Bt((k(), I("div", {
          key: 0,
          role: "button",
          "aria-label": (u = e.ariaLabels) == null ? void 0 : u.toggleOverlay,
          class: he(i(te)),
          tabindex: "0",
          ref_key: "toggleButton",
          ref: $,
          onClick: b,
          onKeydown: ie(b, ["enter"])
        }, [
          K(T.$slots, "button-icon")
        ], 42, Rr)), [
          [Yt, !i(N)(e.type)]
        ]) : P("", !0)
      ], 42, Cr);
    };
  }
}), Or = ["aria-label"], En = /* @__PURE__ */ je({
  __name: "RegularPicker",
  props: {
    ariaLabel: { type: String, default: "" },
    showSelectionGrid: { type: Boolean, default: !1 },
    modelValue: { type: Number, default: null },
    items: { type: Array, default: () => [] },
    disabledValues: { type: Array, default: () => [] },
    minValue: { type: Number, default: null },
    maxValue: { type: Number, default: null },
    slotName: { type: String, default: "" },
    overlaySlot: { type: String, default: "" },
    headerRefs: { type: Array, default: () => [] },
    escClose: { type: Boolean, default: !0 },
    type: { type: String, default: null },
    transitions: { type: [Object, Boolean], default: !1 },
    arrowNavigation: { type: Boolean, default: !1 },
    autoApply: { type: Boolean, default: !1 },
    textInput: { type: Boolean, default: !1 },
    ariaLabels: { type: Object, default: () => ({}) },
    hideNavigation: { type: Array, default: () => [] }
  },
  emits: ["update:model-value", "toggle", "set-ref"],
  setup(e, { emit: n }) {
    const a = e, { transitionName: t, showTransition: o } = Wt(a.transitions), v = H(null);
    return Ue(() => n("set-ref", v)), (g, N) => (k(), I(me, null, [
      ae("button", {
        class: "dp__btn dp__month_year_select",
        onClick: N[0] || (N[0] = (F) => g.$emit("toggle")),
        onKeydown: [
          N[1] || (N[1] = ie((F) => g.$emit("toggle"), ["enter"])),
          N[2] || (N[2] = ie((F) => g.$emit("toggle"), ["space"]))
        ],
        "aria-label": e.ariaLabel,
        tabindex: "0",
        ref_key: "elRef",
        ref: v
      }, [
        K(g.$slots, "default")
      ], 40, Or),
      tt(kt, {
        name: i(t)(e.showSelectionGrid),
        css: i(o)
      }, {
        default: se(() => [
          e.showSelectionGrid ? (k(), ve(At, Se({ key: 0 }, {
            modelValue: e.modelValue,
            items: e.items,
            disabledValues: e.disabledValues,
            minValue: e.minValue,
            maxValue: e.maxValue,
            escClose: e.escClose,
            type: e.type,
            arrowNavigation: e.arrowNavigation,
            textInput: e.textInput,
            autoApply: e.autoApply,
            ariaLabels: e.ariaLabels,
            hideNavigation: e.hideNavigation
          }, {
            "header-refs": [],
            "onUpdate:modelValue": N[3] || (N[3] = (F) => g.$emit("update:model-value", F)),
            onToggle: N[4] || (N[4] = (F) => g.$emit("toggle"))
          }), Ve({
            "button-icon": se(() => [
              g.$slots["calendar-icon"] ? K(g.$slots, "calendar-icon", { key: 0 }) : P("", !0),
              g.$slots["calendar-icon"] ? P("", !0) : (k(), ve(i(Ut), { key: 1 }))
            ]),
            _: 2
          }, [
            g.$slots[e.slotName] ? {
              name: "item",
              fn: se(({ item: F }) => [
                K(g.$slots, e.slotName, { item: F })
              ]),
              key: "0"
            } : void 0,
            g.$slots[e.overlaySlot] ? {
              name: "overlay",
              fn: se(() => [
                K(g.$slots, e.overlaySlot)
              ]),
              key: "1"
            } : void 0,
            g.$slots[`${e.overlaySlot}-header`] ? {
              name: "header",
              fn: se(() => [
                K(g.$slots, `${e.overlaySlot}-header`)
              ]),
              key: "2"
            } : void 0
          ]), 1040)) : P("", !0)
        ]),
        _: 3
      }, 8, ["name", "css"])
    ], 64));
  }
}), Ir = { class: "dp__month_year_row" }, Br = { class: "dp__month_year_wrap" }, Yr = { class: "dp__month_picker_header" }, Vr = ["aria-label"], Er = ["aria-label"], Lr = ["aria-label"], Fr = /* @__PURE__ */ je({
  __name: "MonthYearPicker",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    internalModelValue: { type: [Date, Array], default: null },
    ...rt
  },
  emits: ["update-month-year", "month-year-select", "mount", "reset-flow", "overlay-closed"],
  setup(e, { expose: n, emit: a }) {
    const t = e, { defaults: o } = Ee(t), { transitionName: v, showTransition: g } = Wt(o.value.transitions), { buildMatrix: N } = at(), { handleMonthYearChange: F, isDisabled: C, updateMonthYear: W } = or(t, a), _ = H(!1), d = H(!1), $ = H([null, null, null, null]), X = H(null), G = H(null), x = H(null);
    Ue(() => {
      a("mount");
    });
    const V = (c) => ({
      get: () => t[c],
      set: (S) => {
        const f = c === "month" ? "year" : "month";
        a("update-month-year", { [c]: S, [f]: t[f] }), a("month-year-select", c === "year"), c === "month" ? l(!0) : r(!0);
      }
    }), U = L(V("month")), O = L(V("year")), Z = (c) => {
      const S = we(M(c));
      return t.year === S;
    }, z = L(() => t.monthPicker ? Array.isArray(t.disabledDates) ? t.disabledDates.map((c) => M(c)).filter((c) => Z(c)).map((c) => pe(c)) : [] : []), te = L(() => (c) => {
      const S = c === "month";
      return {
        showSelectionGrid: (S ? _ : d).value,
        items: (S ? Y : T).value,
        disabledValues: o.value.filters[S ? "months" : "years"].concat(z.value),
        minValue: (S ? de : oe).value,
        maxValue: (S ? R : ue).value,
        headerRefs: S && t.monthPicker ? [X.value, G.value, x.value] : [],
        escClose: t.escClose,
        transitions: o.value.transitions,
        ariaLabels: o.value.ariaLabels,
        textInput: t.textInput,
        autoApply: t.autoApply,
        arrowNavigation: t.arrowNavigation,
        hideNavigation: t.hideNavigation
      };
    }), re = L(() => (c) => ({
      month: t.month,
      year: t.year,
      items: c === "month" ? t.months : t.years,
      instance: t.instance,
      updateMonthYear: W,
      toggle: c === "month" ? l : r
    })), oe = L(() => t.minDate ? we(M(t.minDate)) : null), ue = L(() => t.maxDate ? we(M(t.maxDate)) : null), de = L(() => {
      if (t.minDate && oe.value) {
        if (oe.value > t.year)
          return 12;
        if (oe.value === t.year)
          return pe(M(t.minDate));
      }
      return null;
    }), R = L(() => t.maxDate && ue.value ? ue.value < t.year ? -1 : ue.value === t.year ? pe(M(t.maxDate)) : null : null), b = L(() => (t.range || t.multiDates) && t.internalModelValue && (t.monthPicker || t.yearPicker) ? t.internalModelValue : []), m = (c) => {
      const S = [], f = (E) => E;
      for (let E = 0; E < c.length; E += 3) {
        const le = [c[E], c[E + 1], c[E + 2]];
        S.push(f(le));
      }
      return S;
    }, B = L(() => {
      const c = t.months.find((S) => S.value === t.month);
      return c || { text: "", value: 0 };
    }), Y = L(() => m(t.months)), T = L(() => m(t.years)), y = L(() => o.value.multiCalendars ? t.multiCalendarsSolo ? !0 : t.instance === 0 : !0), u = L(() => o.value.multiCalendars ? t.multiCalendarsSolo ? !0 : t.instance === o.value.multiCalendars - 1 : !0), l = (c = !1) => {
      p(c), _.value = !_.value, _.value || a("overlay-closed");
    }, r = (c = !1) => {
      p(c), d.value = !d.value, d.value || a("overlay-closed");
    }, p = (c) => {
      c || a("reset-flow");
    }, w = (c = !1) => {
      C.value(c) || a("update-month-year", {
        year: c ? t.year + 1 : t.year - 1,
        month: t.month,
        fromNav: !0
      });
    }, A = (c, S) => {
      t.arrowNavigation && ($.value[S] = $e(c), N($.value, "monthYear"));
    };
    return n({
      toggleMonthPicker: l,
      toggleYearPicker: r,
      handleMonthYearChange: F
    }), (c, S) => {
      var f, E, le, be, We;
      return k(), I("div", Ir, [
        c.$slots["month-year"] ? K(c.$slots, "month-year", Ne(Se({ key: 0 }, { month: e.month, year: e.year, months: e.months, years: e.years, updateMonthYear: i(W), handleMonthYearChange: i(F), instance: e.instance }))) : (k(), I(me, { key: 1 }, [
          !c.monthPicker && !c.yearPicker ? (k(), I(me, { key: 0 }, [
            i(y) && !c.vertical ? (k(), ve(rn, {
              key: 0,
              "aria-label": (f = i(o).ariaLabels) == null ? void 0 : f.prevMonth,
              disabled: i(C)(!1),
              onActivate: S[0] || (S[0] = (ne) => i(F)(!1)),
              onSetRef: S[1] || (S[1] = (ne) => A(ne, 0))
            }, {
              default: se(() => [
                c.$slots["arrow-left"] ? K(c.$slots, "arrow-left", { key: 0 }) : P("", !0),
                c.$slots["arrow-left"] ? P("", !0) : (k(), ve(i($n), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled"])) : P("", !0),
            ae("div", Br, [
              tt(En, Se({
                type: "month",
                "slot-name": "month-overlay-val",
                "overlay-slot": "overlay-month",
                "aria-label": (E = i(o).ariaLabels) == null ? void 0 : E.openMonthsOverlay,
                modelValue: i(U),
                "onUpdate:modelValue": S[2] || (S[2] = (ne) => ut(U) ? U.value = ne : null)
              }, i(te)("month"), {
                onToggle: l,
                onSetRef: S[3] || (S[3] = (ne) => A(ne, 1))
              }), Ve({
                default: se(() => [
                  c.$slots.month ? K(c.$slots, "month", Ne(Se({ key: 0 }, i(B)))) : P("", !0),
                  c.$slots.month ? P("", !0) : (k(), I(me, { key: 1 }, [
                    Ze(Re(i(B).text), 1)
                  ], 64))
                ]),
                _: 2
              }, [
                c.$slots["calendar-icon"] ? {
                  name: "calendar-icon",
                  fn: se(() => [
                    K(c.$slots, "calendar-icon")
                  ]),
                  key: "0"
                } : void 0,
                c.$slots["month-overlay-value"] ? {
                  name: "month-overlay-val",
                  fn: se(({ item: ne }) => [
                    K(c.$slots, "month-overlay-value", {
                      text: ne.text,
                      value: ne.value
                    })
                  ]),
                  key: "1"
                } : void 0,
                c.$slots["month-overlay"] ? {
                  name: "overlay-month",
                  fn: se(() => [
                    K(c.$slots, "month-overlay", Ne(ze(i(re)("month"))))
                  ]),
                  key: "2"
                } : void 0,
                c.$slots["month-overlay-header"] ? {
                  name: "overlay-month-header",
                  fn: se(() => [
                    K(c.$slots, "month-overlay-header", { toggle: l })
                  ]),
                  key: "3"
                } : void 0
              ]), 1040, ["aria-label", "modelValue"]),
              tt(En, Se({
                type: "year",
                "slot-name": "year-overlay-val",
                "overlay-slot": "overlay-year",
                "aria-label": (le = i(o).ariaLabels) == null ? void 0 : le.openYearsOverlay,
                modelValue: i(O),
                "onUpdate:modelValue": S[4] || (S[4] = (ne) => ut(O) ? O.value = ne : null)
              }, i(te)("year"), {
                onToggle: r,
                onSetRef: S[5] || (S[5] = (ne) => A(ne, 2))
              }), Ve({
                default: se(() => [
                  c.$slots.year ? K(c.$slots, "year", {
                    key: 0,
                    year: e.year
                  }) : P("", !0),
                  c.$slots.year ? P("", !0) : (k(), I(me, { key: 1 }, [
                    Ze(Re(e.year), 1)
                  ], 64))
                ]),
                _: 2
              }, [
                c.$slots["calendar-icon"] ? {
                  name: "calendar-icon",
                  fn: se(() => [
                    K(c.$slots, "calendar-icon")
                  ]),
                  key: "0"
                } : void 0,
                c.$slots["year-overlay-value"] ? {
                  name: "year-overlay-val",
                  fn: se(({ item: ne }) => [
                    K(c.$slots, "year-overlay-value", {
                      text: ne.text,
                      value: ne.value
                    })
                  ]),
                  key: "1"
                } : void 0,
                c.$slots["year-overlay"] ? {
                  name: "overlay-year",
                  fn: se(() => [
                    K(c.$slots, "year-overlay", Ne(ze(i(re)("year"))))
                  ]),
                  key: "2"
                } : void 0,
                c.$slots["year-overlay-header"] ? {
                  name: "overlay-year-header",
                  fn: se(() => [
                    K(c.$slots, "year-overlay-header", { toggle: r })
                  ]),
                  key: "3"
                } : void 0
              ]), 1040, ["aria-label", "modelValue"])
            ]),
            i(y) && c.vertical ? (k(), ve(rn, {
              key: 1,
              "aria-label": (be = i(o).ariaLabels) == null ? void 0 : be.prevMonth,
              disabled: i(C)(!1),
              onActivate: S[6] || (S[6] = (ne) => i(F)(!1))
            }, {
              default: se(() => [
                c.$slots["arrow-up"] ? K(c.$slots, "arrow-up", { key: 0 }) : P("", !0),
                c.$slots["arrow-up"] ? P("", !0) : (k(), ve(i(zn), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled"])) : P("", !0),
            i(u) ? (k(), ve(rn, {
              key: 2,
              ref: "rightIcon",
              disabled: i(C)(!0),
              "aria-label": (We = i(o).ariaLabels) == null ? void 0 : We.nextMonth,
              onActivate: S[7] || (S[7] = (ne) => i(F)(!0)),
              onSetRef: S[8] || (S[8] = (ne) => A(ne, 3))
            }, {
              default: se(() => [
                c.$slots[c.vertical ? "arrow-down" : "arrow-right"] ? K(c.$slots, c.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : P("", !0),
                c.$slots[c.vertical ? "arrow-down" : "arrow-right"] ? P("", !0) : (k(), ve(Ln(c.vertical ? i(Kn) : i(Mn)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label"])) : P("", !0)
          ], 64)) : P("", !0),
          c.monthPicker ? (k(), ve(At, Se({ key: 1 }, i(te)("month"), {
            "skip-active": c.range,
            year: e.year,
            "multi-model-value": i(b),
            "month-picker": "",
            modelValue: i(U),
            "onUpdate:modelValue": S[17] || (S[17] = (ne) => ut(U) ? U.value = ne : null),
            onToggle: l,
            onSelected: S[18] || (S[18] = (ne) => c.$emit("overlay-closed"))
          }), Ve({
            header: se(() => {
              var ne, Le, Ge;
              return [
                ae("div", Yr, [
                  ae("div", {
                    class: "dp__month_year_col_nav",
                    tabindex: "0",
                    ref_key: "mpPrevIconRef",
                    ref: X,
                    onClick: S[9] || (S[9] = (Me) => w(!1)),
                    onKeydown: S[10] || (S[10] = ie((Me) => w(!1), ["enter"]))
                  }, [
                    ae("div", {
                      class: he(["dp__inner_nav", { dp__inner_nav_disabled: i(C)(!1) }]),
                      role: "button",
                      "aria-label": (ne = i(o).ariaLabels) == null ? void 0 : ne.prevMonth
                    }, [
                      c.$slots["arrow-left"] ? K(c.$slots, "arrow-left", { key: 0 }) : P("", !0),
                      c.$slots["arrow-left"] ? P("", !0) : (k(), ve(i($n), { key: 1 }))
                    ], 10, Vr)
                  ], 544),
                  ae("div", {
                    class: "dp__pointer",
                    role: "button",
                    ref_key: "mpYearButtonRef",
                    ref: G,
                    "aria-label": (Le = i(o).ariaLabels) == null ? void 0 : Le.openYearsOverlay,
                    tabindex: "0",
                    onClick: S[11] || (S[11] = () => r(!1)),
                    onKeydown: S[12] || (S[12] = ie(() => r(!1), ["enter"]))
                  }, [
                    c.$slots.year ? K(c.$slots, "year", {
                      key: 0,
                      year: e.year
                    }) : P("", !0),
                    c.$slots.year ? P("", !0) : (k(), I(me, { key: 1 }, [
                      Ze(Re(e.year), 1)
                    ], 64))
                  ], 40, Er),
                  ae("div", {
                    class: "dp__month_year_col_nav",
                    tabindex: "0",
                    ref_key: "mpNextIconRef",
                    ref: x,
                    onClick: S[13] || (S[13] = (Me) => w(!0)),
                    onKeydown: S[14] || (S[14] = ie((Me) => w(!0), ["enter"]))
                  }, [
                    ae("div", {
                      class: he(["dp__inner_nav", { dp__inner_nav_disabled: i(C)(!0) }]),
                      role: "button",
                      "aria-label": (Ge = i(o).ariaLabels) == null ? void 0 : Ge.nextMonth
                    }, [
                      c.$slots["arrow-right"] ? K(c.$slots, "arrow-right", { key: 0 }) : P("", !0),
                      c.$slots["arrow-right"] ? P("", !0) : (k(), ve(i(Mn), { key: 1 }))
                    ], 10, Lr)
                  ], 544)
                ]),
                tt(kt, {
                  name: i(v)(d.value),
                  css: i(g)
                }, {
                  default: se(() => [
                    d.value ? (k(), ve(At, Se({ key: 0 }, i(te)("year"), {
                      modelValue: i(O),
                      "onUpdate:modelValue": S[15] || (S[15] = (Me) => ut(O) ? O.value = Me : null),
                      onToggle: r,
                      onSelected: S[16] || (S[16] = (Me) => c.$emit("overlay-closed"))
                    }), Ve({
                      "button-icon": se(() => [
                        c.$slots["calendar-icon"] ? K(c.$slots, "calendar-icon", { key: 0 }) : P("", !0),
                        c.$slots["calendar-icon"] ? P("", !0) : (k(), ve(i(Ut), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      c.$slots["year-overlay-value"] ? {
                        name: "item",
                        fn: se(({ item: Me }) => [
                          K(c.$slots, "year-overlay-value", {
                            text: Me.text,
                            value: Me.value
                          })
                        ]),
                        key: "0"
                      } : void 0
                    ]), 1040, ["modelValue"])) : P("", !0)
                  ]),
                  _: 3
                }, 8, ["name", "css"])
              ];
            }),
            _: 2
          }, [
            c.$slots["month-overlay-value"] ? {
              name: "item",
              fn: se(({ item: ne }) => [
                K(c.$slots, "month-overlay-value", {
                  text: ne.text,
                  value: ne.value
                })
              ]),
              key: "0"
            } : void 0
          ]), 1040, ["skip-active", "year", "multi-model-value", "modelValue"])) : P("", !0),
          c.yearPicker ? (k(), ve(At, Se({ key: 2 }, i(te)("year"), {
            modelValue: i(O),
            "onUpdate:modelValue": S[19] || (S[19] = (ne) => ut(O) ? O.value = ne : null),
            "multi-model-value": i(b),
            "skip-active": c.range,
            "skip-button-ref": "",
            "year-picker": "",
            onToggle: r,
            onSelected: S[20] || (S[20] = (ne) => c.$emit("overlay-closed"))
          }), Ve({ _: 2 }, [
            c.$slots["year-overlay-value"] ? {
              name: "item",
              fn: se(({ item: ne }) => [
                K(c.$slots, "year-overlay-value", {
                  text: ne.text,
                  value: ne.value
                })
              ]),
              key: "0"
            } : void 0
          ]), 1040, ["modelValue", "multi-model-value", "skip-active"])) : P("", !0)
        ], 64))
      ]);
    };
  }
}), Ur = {
  key: 0,
  class: "dp__time_input"
}, Wr = ["aria-label", "onKeydown", "onClick"], Hr = ["aria-label", "onKeydown", "onClick"], xr = ["aria-label", "onKeydown", "onClick"], zr = { key: 0 }, Kr = ["aria-label", "onKeydown"], jr = /* @__PURE__ */ je({
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    ...rt
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed"
  ],
  setup(e, { expose: n, emit: a }) {
    const t = e, { setTimePickerElements: o, setTimePickerBackRef: v } = at(), { defaults: g } = Ee(t), { transitionName: N, showTransition: F } = Wt(g.value.transitions), C = _t({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), W = H("AM"), _ = H(null), d = H([]);
    Ue(() => {
      a("mounted");
    });
    const $ = (l) => Ce(/* @__PURE__ */ new Date(), {
      hours: l.hours,
      minutes: l.minutes,
      seconds: t.enableSeconds ? l.seconds : 0,
      milliseconds: 0
    }), X = L(() => ({ hours: t.hours, minutes: t.minutes, seconds: t.seconds })), G = L(() => (l) => !oe(+t[l] + +t[`${l}Increment`], l)), x = L(() => (l) => !oe(+t[l] - +t[`${l}Increment`], l)), V = (l, r) => Hn(Ce(M(), l), r), U = (l, r) => ma(Ce(M(), l), r), O = L(
      () => ({
        dp__time_col: !0,
        dp__time_col_reg: !t.enableSeconds && t.is24,
        dp__time_col_reg_with_button: !t.enableSeconds && !t.is24,
        dp__time_col_sec: t.enableSeconds && t.is24,
        dp__time_col_sec_with_button: t.enableSeconds && !t.is24
      })
    ), Z = L(() => {
      const l = [{ type: "hours" }, { type: "", separator: !0 }, { type: "minutes" }];
      return t.enableSeconds ? l.concat([{ type: "", separator: !0 }, { type: "seconds" }]) : l;
    }), z = L(() => Z.value.filter((l) => !l.separator)), te = L(() => (l) => {
      if (l === "hours") {
        const r = B(+t.hours);
        return { text: r < 10 ? `0${r}` : `${r}`, value: r };
      }
      return { text: t[l] < 10 ? `0${t[l]}` : `${t[l]}`, value: t[l] };
    }), re = (l) => {
      const r = t.is24 ? 24 : 12, p = l === "hours" ? r : 60, w = +t[`${l}GridIncrement`], A = l === "hours" && !t.is24 ? w : 0, c = [];
      for (let S = A; S < p; S += w)
        c.push({ value: S, text: S < 10 ? `0${S}` : `${S}` });
      return l === "hours" && !t.is24 && c.push({ value: 0, text: "12" }), za(c);
    }, oe = (l, r) => {
      const p = t.minTime ? $(Zt(t.minTime)) : null, w = t.maxTime ? $(Zt(t.maxTime)) : null, A = $(Zt(X.value, r, l));
      return p && w ? (Pt(A, w) || ht(A, w)) && (Ct(A, p) || ht(A, p)) : p ? Ct(A, p) || ht(A, p) : w ? Pt(A, w) || ht(A, w) : !0;
    }, ue = L(() => (l) => re(l).flat().filter((p) => p || p.value === 0).map((p) => p.value).filter((p) => (l === "hours" && console.log(!oe(p, l), p), !oe(p, l)))), de = (l) => t[`no${l[0].toUpperCase() + l.slice(1)}Overlay`], R = (l) => {
      de(l) || (C[l] = !C[l], C[l] || a("overlay-closed"));
    }, b = (l) => l === "hours" ? qe : l === "minutes" ? Xe : pt, m = (l, r = !0) => {
      const p = r ? V : U, w = r ? +t[`${l}Increment`] : -+t[`${l}Increment`];
      oe(+t[l] + w, l) && a(
        `update:${l}`,
        b(l)(p({ [l]: +t[l] }, { [l]: +t[`${l}Increment`] }))
      );
    }, B = (l) => t.is24 ? l : (l >= 12 ? W.value = "PM" : W.value = "AM", Za(l)), Y = () => {
      W.value === "PM" ? (W.value = "AM", a("update:hours", t.hours - 12)) : (W.value = "PM", a("update:hours", t.hours + 12));
    }, T = (l) => {
      C[l] = !0;
    }, y = (l, r, p) => {
      if (l && t.arrowNavigation) {
        Array.isArray(d.value[r]) ? d.value[r][p] = l : d.value[r] = [l];
        const w = d.value.reduce(
          (A, c) => c.map((S, f) => [...A[f] || [], c[f]]),
          []
        );
        v(t.closeTimePickerBtn), _.value && (w[1] = w[1].concat(_.value)), o(w, t.order);
      }
    }, u = (l, r) => l === "hours" && !t.is24 ? a(`update:${l}`, W.value === "PM" ? r + 12 : r) : a(`update:${l}`, r);
    return n({ openChildCmp: T }), (l, r) => {
      var p;
      return l.disabled ? P("", !0) : (k(), I("div", Ur, [
        (k(!0), I(me, null, Pe(i(Z), (w, A) => {
          var c, S, f;
          return k(), I("div", {
            key: A,
            class: he(i(O))
          }, [
            w.separator ? (k(), I(me, { key: 0 }, [
              Ze(" : ")
            ], 64)) : (k(), I(me, { key: 1 }, [
              ae("button", {
                class: he({
                  dp__btn: !0,
                  dp__inc_dec_button: !0,
                  dp__inc_dec_button_disabled: i(G)(w.type)
                }),
                "aria-label": (c = i(g).ariaLabels) == null ? void 0 : c.incrementValue(w.type),
                tabindex: "0",
                onKeydown: [
                  ie((E) => m(w.type), ["enter"]),
                  ie((E) => m(w.type), ["space"])
                ],
                onClick: (E) => m(w.type),
                ref_for: !0,
                ref: (E) => y(E, A, 0)
              }, [
                l.$slots["arrow-up"] ? K(l.$slots, "arrow-up", { key: 0 }) : P("", !0),
                l.$slots["arrow-up"] ? P("", !0) : (k(), ve(i(zn), { key: 1 }))
              ], 42, Wr),
              ae("button", {
                "aria-label": (S = i(g).ariaLabels) == null ? void 0 : S.openTpOverlay(w.type),
                class: he(["dp__btn", de(w.type) ? "" : "dp__time_display"]),
                tabindex: "0",
                onKeydown: [
                  ie((E) => R(w.type), ["enter"]),
                  ie((E) => R(w.type), ["space"])
                ],
                onClick: (E) => R(w.type),
                ref_for: !0,
                ref: (E) => y(E, A, 1)
              }, [
                l.$slots[w.type] ? K(l.$slots, w.type, {
                  key: 0,
                  text: i(te)(w.type).text,
                  value: i(te)(w.type).value
                }) : P("", !0),
                l.$slots[w.type] ? P("", !0) : (k(), I(me, { key: 1 }, [
                  Ze(Re(i(te)(w.type).text), 1)
                ], 64))
              ], 42, Hr),
              ae("button", {
                class: he({
                  dp__btn: !0,
                  dp__inc_dec_button: !0,
                  dp__inc_dec_button_disabled: i(x)(w.type)
                }),
                "aria-label": (f = i(g).ariaLabels) == null ? void 0 : f.decrementValue(w.type),
                tabindex: "0",
                onKeydown: [
                  ie((E) => m(w.type, !1), ["enter"]),
                  ie((E) => m(w.type, !1), ["space"])
                ],
                onClick: (E) => m(w.type, !1),
                ref_for: !0,
                ref: (E) => y(E, A, 2)
              }, [
                l.$slots["arrow-down"] ? K(l.$slots, "arrow-down", { key: 0 }) : P("", !0),
                l.$slots["arrow-down"] ? P("", !0) : (k(), ve(i(Kn), { key: 1 }))
              ], 42, xr)
            ], 64))
          ], 2);
        }), 128)),
        l.is24 ? P("", !0) : (k(), I("div", zr, [
          l.$slots["am-pm-button"] ? K(l.$slots, "am-pm-button", {
            key: 0,
            toggle: Y,
            value: W.value
          }) : P("", !0),
          l.$slots["am-pm-button"] ? P("", !0) : (k(), I("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: _,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (p = i(g).ariaLabels) == null ? void 0 : p.amPmButton,
            tabindex: "0",
            onClick: Y,
            onKeydown: [
              ie(Je(Y, ["prevent"]), ["enter"]),
              ie(Je(Y, ["prevent"]), ["space"])
            ]
          }, Re(W.value), 41, Kr))
        ])),
        (k(!0), I(me, null, Pe(i(z), (w, A) => (k(), ve(kt, {
          key: A,
          name: i(N)(C[w.type]),
          css: i(F)
        }, {
          default: se(() => [
            C[w.type] ? (k(), ve(At, {
              key: 0,
              items: re(w.type),
              "disabled-values": i(g).filters.times[w.type].concat(i(ue)(w.type)),
              "esc-close": l.escClose,
              "aria-labels": i(g).ariaLabels,
              "hide-navigation": l.hideNavigation,
              "onUpdate:modelValue": (c) => u(w.type, c),
              onSelected: (c) => R(w.type),
              onToggle: (c) => R(w.type),
              onResetFlow: r[0] || (r[0] = (c) => l.$emit("reset-flow")),
              type: w.type
            }, Ve({
              "button-icon": se(() => [
                l.$slots["clock-icon"] ? K(l.$slots, "clock-icon", { key: 0 }) : P("", !0),
                l.$slots["clock-icon"] ? P("", !0) : (k(), ve(i(xn), { key: 1 }))
              ]),
              _: 2
            }, [
              l.$slots[`${w.type}-overlay-value`] ? {
                name: "item",
                fn: se(({ item: c }) => [
                  K(l.$slots, `${w.type}-overlay-value`, {
                    text: c.text,
                    value: c.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "disabled-values", "esc-close", "aria-labels", "hide-navigation", "onUpdate:modelValue", "onSelected", "onToggle", "type"])) : P("", !0)
          ]),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), Gr = ["aria-label"], Zr = { class: "dp__overlay_container dp__container_flex dp__time_picker_overlay_container" }, qr = {
  key: 1,
  class: "dp__overlay_row dp__flex_row"
}, Xr = ["aria-label"], Jr = /* @__PURE__ */ je({
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    internalModelValue: { type: [Date, Array], default: null },
    ...rt
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed"
  ],
  setup(e, { expose: n, emit: a }) {
    const t = e, { buildMatrix: o, setTimePicker: v } = at(), g = yn(), { hideNavigationButtons: N, defaults: F } = Ee(t), { transitionName: C, showTransition: W } = Wt(F.value.transitions), _ = H(null), d = H(null), $ = H([]), X = H(null);
    Ue(() => {
      a("mount"), !t.timePicker && t.arrowNavigation ? o([$e(_.value)], "time") : v(!0, t.timePicker);
    });
    const G = L(() => t.range && t.modelAuto ? Jn(t.internalModelValue) : !0), x = H(!1), V = (R) => ({
      hours: Array.isArray(t.hours) ? t.hours[R] : t.hours,
      minutes: Array.isArray(t.minutes) ? t.minutes[R] : t.minutes,
      seconds: Array.isArray(t.seconds) ? t.seconds[R] : t.seconds
    }), U = L(() => {
      const R = [];
      if (t.range)
        for (let b = 0; b < 2; b++)
          R.push(V(b));
      else
        R.push(V(0));
      return R;
    }), O = (R, b = !1, m = "") => {
      b || a("reset-flow"), x.value = R, R && a("overlay-opened"), t.arrowNavigation && (v(R), R || a("overlay-closed")), Qe(() => {
        m !== "" && $.value[0] && $.value[0].openChildCmp(m);
      });
    }, Z = L(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: t.autoApply && !t.keepActionRow
    })), z = ft(g, "timePicker"), te = (R, b, m) => t.range ? b === 0 ? [R, U.value[1][m]] : [U.value[0][m], R] : R, re = (R) => {
      a("update:hours", R);
    }, oe = (R) => {
      a("update:minutes", R);
    }, ue = (R) => {
      a("update:seconds", R);
    }, de = () => {
      X.value && t.arrowNavigation && X.value.focus({ preventScroll: !0 });
    };
    return n({ toggleTimePicker: O }), (R, b) => {
      var m;
      return k(), I("div", null, [
        R.timePicker ? P("", !0) : Bt((k(), I("button", {
          key: 0,
          class: he(i(Z)),
          "aria-label": (m = i(F).ariaLabels) == null ? void 0 : m.openTimePicker,
          tabindex: "0",
          ref_key: "openTimePickerBtn",
          ref: _,
          onKeydown: [
            b[0] || (b[0] = ie((B) => O(!0), ["enter"])),
            b[1] || (b[1] = ie((B) => O(!0), ["space"]))
          ],
          onClick: b[2] || (b[2] = (B) => O(!0))
        }, [
          R.$slots["clock-icon"] ? K(R.$slots, "clock-icon", { key: 0 }) : P("", !0),
          R.$slots["clock-icon"] ? P("", !0) : (k(), ve(i(xn), { key: 1 }))
        ], 42, Gr)), [
          [Yt, !i(N)("time")]
        ]),
        tt(kt, {
          name: i(C)(x.value),
          css: i(W)
        }, {
          default: se(() => {
            var B;
            return [
              x.value || R.timePicker ? (k(), I("div", {
                key: 0,
                class: "dp__overlay",
                ref_key: "overlayRef",
                ref: X,
                tabindex: "0"
              }, [
                ae("div", Zr, [
                  R.$slots["time-picker-overlay"] ? K(R.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: e.hours,
                    minutes: e.minutes,
                    seconds: e.seconds,
                    setHours: re,
                    setMinutes: oe,
                    setSeconds: ue
                  }) : P("", !0),
                  R.$slots["time-picker-overlay"] ? P("", !0) : (k(), I("div", qr, [
                    (k(!0), I(me, null, Pe(i(U), (Y, T) => Bt((k(), ve(jr, Se({ key: T }, {
                      ...R.$props,
                      order: T,
                      hours: Y.hours,
                      minutes: Y.minutes,
                      seconds: Y.seconds,
                      closeTimePickerBtn: d.value,
                      disabled: T === 0 ? R.fixedStart : R.fixedEnd
                    }, {
                      ref_for: !0,
                      ref_key: "timeInputRefs",
                      ref: $,
                      "onUpdate:hours": (y) => re(te(y, T, "hours")),
                      "onUpdate:minutes": (y) => oe(te(y, T, "minutes")),
                      "onUpdate:seconds": (y) => ue(te(y, T, "seconds")),
                      onMounted: de,
                      onOverlayClosed: de
                    }), Ve({ _: 2 }, [
                      Pe(i(z), (y, u) => ({
                        name: y,
                        fn: se((l) => [
                          K(R.$slots, y, Ne(ze(l)))
                        ])
                      }))
                    ]), 1040, ["onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [Yt, T === 0 ? !0 : i(G)]
                    ])), 128))
                  ])),
                  R.timePicker ? P("", !0) : Bt((k(), I("button", {
                    key: 2,
                    ref_key: "closeTimePickerBtn",
                    ref: d,
                    class: he(i(Z)),
                    "aria-label": (B = i(F).ariaLabels) == null ? void 0 : B.closeTimePicker,
                    tabindex: "0",
                    onKeydown: [
                      b[3] || (b[3] = ie((Y) => O(!1), ["enter"])),
                      b[4] || (b[4] = ie((Y) => O(!1), ["space"]))
                    ],
                    onClick: b[5] || (b[5] = (Y) => O(!1))
                  }, [
                    R.$slots["calendar-icon"] ? K(R.$slots, "calendar-icon", { key: 0 }) : P("", !0),
                    R.$slots["calendar-icon"] ? P("", !0) : (k(), ve(i(Ut), { key: 1 }))
                  ], 42, Xr)), [
                    [Yt, !i(N)("time")]
                  ])
                ])
              ], 512)) : P("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), Qr = (e, n) => {
  const { isDisabled: a, matchDate: t, getWeekFromDate: o, defaults: v } = Ee(n), g = H(null), N = H(M()), F = (r) => {
    !r.current && n.hideOffsetDates || (g.value = r.value);
  }, C = () => {
    g.value = null;
  }, W = (r) => Array.isArray(e.value) && n.range && e.value[0] && g.value ? r ? Ye(g.value, e.value[0]) : Oe(g.value, e.value[0]) : !0, _ = (r, p) => {
    const w = () => e.value ? p ? e.value[0] || null : e.value[1] : null, A = e.value && Array.isArray(e.value) ? w() : null;
    return ge(M(r.value), A);
  }, d = (r) => {
    const p = Array.isArray(e.value) ? e.value[0] : null;
    return r ? !Oe(g.value || null, p) : !0;
  }, $ = (r, p = !0) => (n.range || n.weekPicker) && Array.isArray(e.value) && e.value.length === 2 ? n.hideOffsetDates && !r.current ? !1 : ge(M(r.value), e.value[p ? 0 : 1]) : n.range ? _(r, p) && d(p) || ge(r.value, Array.isArray(e.value) ? e.value[0] : null) && W(p) : !1, X = (r, p, w) => Array.isArray(e.value) && e.value[0] && e.value.length === 1 ? r ? !1 : w ? Ye(e.value[0], p.value) : Oe(e.value[0], p.value) : !1, G = (r) => !e.value || n.hideOffsetDates && !r.current ? !1 : n.range ? n.modelAuto && Array.isArray(e.value) ? ge(r.value, e.value[0] ? e.value[0] : N.value) : !1 : n.multiDates && Array.isArray(e.value) ? e.value.some((p) => ge(p, r.value)) : ge(r.value, e.value ? e.value : N.value), x = (r) => {
    if (n.autoRange || n.weekPicker) {
      if (g.value) {
        if (n.hideOffsetDates && !r.current)
          return !1;
        const p = dt(g.value, +n.autoRange), w = o(M(g.value));
        return n.weekPicker ? ge(w[1], M(r.value)) : ge(p, M(r.value));
      }
      return !1;
    }
    return !1;
  }, V = (r) => {
    if (n.autoRange || n.weekPicker) {
      if (g.value) {
        const p = dt(g.value, +n.autoRange);
        if (n.hideOffsetDates && !r.current)
          return !1;
        const w = o(M(g.value));
        return n.weekPicker ? Ye(r.value, w[0]) && Oe(r.value, w[1]) : Ye(r.value, g.value) && Oe(r.value, p);
      }
      return !1;
    }
    return !1;
  }, U = (r) => {
    if (n.autoRange || n.weekPicker) {
      if (g.value) {
        if (n.hideOffsetDates && !r.current)
          return !1;
        const p = o(M(g.value));
        return n.weekPicker ? ge(p[0], r.value) : ge(g.value, r.value);
      }
      return !1;
    }
    return !1;
  }, O = (r) => jn(e.value, g.value, r.value), Z = () => n.modelAuto && Array.isArray(n.internalModelValue) ? !!n.internalModelValue[0] : !1, z = () => n.modelAuto ? Jn(n.internalModelValue) : !0, te = (r) => {
    if (Array.isArray(e.value) && e.value.length || n.weekPicker)
      return !1;
    const p = n.range ? !$(r) && !$(r, !1) : !0;
    return !a(r.value) && !G(r) && !(!r.current && n.hideOffsetDates) && p;
  }, re = (r) => n.range ? n.modelAuto ? Z() && G(r) : !1 : G(r), oe = (r) => n.highlight ? t(r.value, n.highlight) : !1, ue = (r) => a(r.value) && n.highlightDisabledDays === !1, de = (r) => n.highlightWeekDays && n.highlightWeekDays.includes(r.value.getDay()), R = (r) => (n.range || n.weekPicker) && (!(v.value.multiCalendars > 0) || r.current) && z() && !(!r.current && n.hideOffsetDates) && !G(r) ? O(r) : !1, b = (r) => {
    const { isRangeStart: p, isRangeEnd: w } = Y(r), A = n.range ? p || w : !1;
    return {
      dp__cell_offset: !r.current,
      dp__pointer: !n.disabled && !(!r.current && n.hideOffsetDates) && !a(r.value),
      dp__cell_disabled: a(r.value),
      dp__cell_highlight: !ue(r) && (oe(r) || de(r)) && !re(r) && !A,
      dp__cell_highlight_active: !ue(r) && (oe(r) || de(r)) && re(r),
      dp__today: !n.noToday && ge(r.value, N.value) && r.current
    };
  }, m = (r) => ({
    dp__active_date: re(r),
    dp__date_hover: te(r)
  }), B = (r) => ({
    ...T(r),
    ...y(r),
    dp__range_between_week: R(r) && n.weekPicker
  }), Y = (r) => {
    const p = v.value.multiCalendars > 0 ? r.current && $(r) && z() : $(r) && z(), w = v.value.multiCalendars > 0 ? r.current && $(r, !1) && z() : $(r, !1) && z();
    return { isRangeStart: p, isRangeEnd: w };
  }, T = (r) => {
    const { isRangeStart: p, isRangeEnd: w } = Y(r);
    return {
      dp__range_start: p,
      dp__range_end: w,
      dp__range_between: R(r) && !n.weekPicker,
      dp__date_hover_start: X(te(r), r, !0),
      dp__date_hover_end: X(te(r), r, !1)
    };
  }, y = (r) => ({
    ...T(r),
    dp__cell_auto_range: V(r),
    dp__cell_auto_range_start: U(r),
    dp__cell_auto_range_end: x(r)
  }), u = (r) => n.range ? n.autoRange ? y(r) : n.modelAuto ? { ...m(r), ...T(r) } : T(r) : n.weekPicker ? B(r) : m(r);
  return {
    setHoverDate: F,
    clearHoverDate: C,
    getDayClassData: (r) => ({
      ...b(r),
      ...u(r),
      [n.dayClass ? n.dayClass(r.value) : ""]: !0,
      [n.calendarCellClassName]: !!n.calendarCellClassName
    })
  };
}, el = ["id", "onKeydown"], tl = {
  key: 0,
  class: "dp__sidebar_left"
}, nl = {
  key: 1,
  class: "dp__preset_ranges"
}, al = ["onClick"], rl = {
  key: 2,
  class: "dp__sidebar_right"
}, ll = {
  key: 3,
  class: "dp__action_extra"
}, ol = /* @__PURE__ */ je({
  __name: "DatepickerMenu",
  props: {
    openOnTop: { type: Boolean, default: !1 },
    ready: { type: Number, default: 0 },
    internalModelValue: { type: [Date, Array], default: null },
    ...rt
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open"
  ],
  setup(e, { expose: n, emit: a }) {
    const t = e, o = L(() => {
      const { openOnTop: h, ready: j, internalModelValue: De, ...Te } = t;
      return Te;
    }), { setMenuFocused: v, setShiftKey: g, control: N } = Gn(), { getCalendarDays: F, defaults: C } = Ee(t), W = yn(), _ = H(null), d = _t({
      timePicker: !!(!t.enableTimePicker || t.timePicker || t.monthPicker),
      monthYearInput: !!t.timePicker,
      calendar: !1
    }), $ = H([]), X = H([]), G = H(null), x = H(null), V = H(0), U = H(!1), O = H(0);
    Ue(() => {
      var j;
      U.value = !0, !((j = t.presetRanges) != null && j.length) && !W["left-sidebar"] && !W["right-sidebar"] && (Q(), window.addEventListener("resize", Q));
      const h = $e(x);
      if (h && !t.textInput && !t.inline && (v(!0), ue()), h) {
        const De = (Te) => {
          t.allowPreventDefault && Te.preventDefault(), Te.stopImmediatePropagation(), Te.stopPropagation();
        };
        h.addEventListener("pointerdown", De), h.addEventListener("mousedown", De);
      }
    }), mn(() => {
      window.removeEventListener("resize", Q);
    });
    const { arrowRight: Z, arrowLeft: z, arrowDown: te, arrowUp: re } = at(), oe = (h) => {
      h || h === 0 ? X.value[h].triggerTransition(
        B.value(h),
        Y.value(h)
      ) : X.value.forEach(
        (j, De) => j.triggerTransition(B.value(De), Y.value(De))
      );
    }, ue = () => {
      const h = $e(x);
      h && h.focus({ preventScroll: !0 });
    }, de = () => {
      var h;
      (h = t.flow) != null && h.length && O.value !== -1 && (O.value += 1, a("flow-step", O.value), s());
    }, R = () => {
      O.value = -1;
    }, {
      calendars: b,
      modelValue: m,
      month: B,
      year: Y,
      time: T,
      updateTime: y,
      updateMonthYear: u,
      selectDate: l,
      getWeekNum: r,
      monthYearSelect: p,
      handleScroll: w,
      handleArrow: A,
      handleSwipe: c,
      getMarker: S,
      selectCurrentDate: f,
      presetDateRange: E
    } = rr(t, a, de, oe, O), { setHoverDate: le, clearHoverDate: be, getDayClassData: We } = Qr(m, t);
    nt(
      b,
      () => {
        t.openOnTop && setTimeout(() => {
          a("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    );
    const ne = ft(W, "calendar"), Le = ft(W, "action"), Ge = ft(W, "timePicker"), Me = ft(W, "monthYear"), He = L(() => t.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), lt = L(() => ja(t.yearRange, t.reverseYears)), wt = L(() => Ga(t.locale, t.monthNameFormat)), Q = () => {
      const h = $e(_);
      h && (V.value = h.getBoundingClientRect().width);
    }, ye = L(() => (h) => F(B.value(h), Y.value(h))), fe = L(
      () => C.value.multiCalendars > 0 && t.range ? [...Array(C.value.multiCalendars).keys()] : [0]
    ), ot = L(
      () => (h) => h === 1
    ), st = L(() => t.monthPicker || t.timePicker || t.yearPicker), Ht = L(
      () => ({
        dp__menu_inner: !0,
        dp__flex_display: C.value.multiCalendars > 0
      })
    ), xt = L(() => ({
      dp__instance_calendar: C.value.multiCalendars > 0
    })), Nt = L(() => ({
      dp__menu_disabled: t.disabled,
      dp__menu_readonly: t.readonly
    })), bt = L(
      () => (h) => Kt(ye, h)
    ), zt = L(
      () => ({
        dp__menu: !0,
        dp__menu_index: !t.inline,
        dp__relative: t.inline,
        [t.menuClassName]: !!t.menuClassName
      })
    ), Kt = (h, j) => h.value(j).map((De) => ({
      ...De,
      days: De.days.map((Te) => (Te.marker = S(Te), Te.classData = We(Te), Te))
    })), jt = (h) => {
      h.stopPropagation(), h.stopImmediatePropagation();
    }, Rt = () => {
      t.escClose && a("close-picker");
    }, wn = (h, j = !1) => {
      l(h, j), t.spaceConfirm && a("select-date");
    }, Ot = (h) => {
      var j;
      (j = t.flow) != null && j.length && (d[h] = !0, Object.keys(d).filter((De) => !d[De]).length || s());
    }, mt = (h, j, De, Te, ...xe) => {
      if (t.flow[O.value] === h) {
        const J = Te ? j.value[0] : j.value;
        J && J[De](...xe);
      }
    }, s = () => {
      mt("month", $, "toggleMonthPicker", !0, !0), mt("year", $, "toggleYearPicker", !0, !0), mt("calendar", G, "toggleTimePicker", !1, !1, !0), mt("time", G, "toggleTimePicker", !1, !0, !0);
      const h = t.flow[O.value];
      (h === "hours" || h === "minutes" || h === "seconds") && mt(h, G, "toggleTimePicker", !1, !0, !0, h);
    }, D = (h) => {
      if (t.arrowNavigation) {
        if (h === "up")
          return re();
        if (h === "down")
          return te();
        if (h === "left")
          return z();
        if (h === "right")
          return Z();
      } else
        h === "left" || h === "up" ? A("left", 0, h === "up") : A("right", 0, h === "down");
    }, q = (h) => {
      g(h.shiftKey), !t.disableMonthYearSelect && h.code === "Tab" && h.target.classList.contains("dp__menu") && N.value.shiftKeyInMenu && (h.preventDefault(), h.stopImmediatePropagation(), a("close-picker"));
    }, ee = (h) => {
      $.value[0] && $.value[0].handleMonthYearChange(h);
    };
    return n({
      updateMonthYear: u
    }), (h, j) => {
      var De;
      return k(), ve(kt, {
        appear: "",
        name: (De = i(C).transitions) == null ? void 0 : De.menuAppear,
        css: !!h.transitions,
        key: e.ready
      }, {
        default: se(() => {
          var Te, xe;
          return [
            ae("div", {
              id: h.uid ? `dp-menu-${h.uid}` : void 0,
              tabindex: "0",
              ref_key: "dpMenuRef",
              ref: x,
              role: "dialog",
              class: he(i(zt)),
              onMouseleave: j[13] || (j[13] = //@ts-ignore
              (...J) => i(be) && i(be)(...J)),
              onClick: jt,
              onKeydown: [
                ie(Rt, ["esc"]),
                j[14] || (j[14] = ie(Je((J) => D("left"), ["prevent"]), ["left"])),
                j[15] || (j[15] = ie(Je((J) => D("up"), ["prevent"]), ["up"])),
                j[16] || (j[16] = ie(Je((J) => D("down"), ["prevent"]), ["down"])),
                j[17] || (j[17] = ie(Je((J) => D("right"), ["prevent"]), ["right"])),
                q
              ]
            }, [
              (h.disabled || h.readonly) && h.inline ? (k(), I("div", {
                key: 0,
                class: he(i(Nt))
              }, null, 2)) : P("", !0),
              !h.inline && !h.teleportCenter ? (k(), I("div", {
                key: 1,
                class: he(i(He))
              }, null, 2)) : P("", !0),
              ae("div", {
                class: he({
                  dp__menu_content_wrapper: ((Te = h.presetRanges) == null ? void 0 : Te.length) || !!h.$slots["left-sidebar"] || !!h.$slots["right-sidebar"]
                })
              }, [
                h.$slots["left-sidebar"] ? (k(), I("div", tl, [
                  K(h.$slots, "left-sidebar", Ne(ze({ handleMonthYearChange: ee })))
                ])) : P("", !0),
                (xe = h.presetRanges) != null && xe.length ? (k(), I("div", nl, [
                  (k(!0), I(me, null, Pe(h.presetRanges, (J, yt) => (k(), I("div", {
                    key: yt,
                    style: et(J.style || {}),
                    class: "dp__preset_range",
                    onClick: (ce) => i(E)(J.range, !!J.slot)
                  }, [
                    J.slot ? K(h.$slots, J.slot, {
                      key: 0,
                      presetDateRange: i(E),
                      label: J.label,
                      range: J.range
                    }) : (k(), I(me, { key: 1 }, [
                      Ze(Re(J.label), 1)
                    ], 64))
                  ], 12, al))), 128))
                ])) : P("", !0),
                ae("div", {
                  class: "dp__instance_calendar",
                  ref_key: "calendarWrapperRef",
                  ref: _,
                  role: "document"
                }, [
                  ae("div", {
                    class: he(i(Ht))
                  }, [
                    (k(!0), I(me, null, Pe(i(fe), (J, yt) => (k(), I("div", {
                      key: J,
                      class: he(i(xt))
                    }, [
                      !h.disableMonthYearSelect && !h.timePicker ? (k(), ve(Fr, Se({
                        key: 0,
                        ref_for: !0,
                        ref: (ce) => {
                          ce && ($.value[yt] = ce);
                        },
                        months: i(wt),
                        years: i(lt),
                        month: i(B)(J),
                        year: i(Y)(J),
                        instance: J,
                        "internal-model-value": e.internalModelValue
                      }, i(o), {
                        onMount: j[0] || (j[0] = (ce) => Ot("monthYearInput")),
                        onResetFlow: R,
                        onUpdateMonthYear: (ce) => i(u)(J, ce),
                        onMonthYearSelect: i(p),
                        onOverlayClosed: ue
                      }), Ve({ _: 2 }, [
                        Pe(i(Me), (ce, ea) => ({
                          name: ce,
                          fn: se((Gt) => [
                            K(h.$slots, ce, Ne(ze(Gt)))
                          ])
                        }))
                      ]), 1040, ["months", "years", "month", "year", "instance", "internal-model-value", "onUpdateMonthYear", "onMonthYearSelect"])) : P("", !0),
                      tt(Sr, Se({
                        ref_for: !0,
                        ref: (ce) => {
                          ce && (X.value[yt] = ce);
                        },
                        "specific-mode": i(st),
                        "get-week-num": i(r),
                        instance: J,
                        "mapped-dates": i(bt)(J),
                        month: i(B)(J),
                        year: i(Y)(J)
                      }, i(o), {
                        onSelectDate: (ce) => i(l)(ce, !i(ot)(J)),
                        onHandleSpace: (ce) => wn(ce, !i(ot)(J)),
                        onSetHoverDate: j[1] || (j[1] = (ce) => i(le)(ce)),
                        onHandleScroll: (ce) => i(w)(ce, J),
                        onHandleSwipe: (ce) => i(c)(ce, J),
                        onMount: j[2] || (j[2] = (ce) => Ot("calendar")),
                        onResetFlow: R,
                        onTooltipOpen: j[3] || (j[3] = (ce) => h.$emit("tooltip-open", ce)),
                        onTooltipClose: j[4] || (j[4] = (ce) => h.$emit("tooltip-close", ce))
                      }), Ve({ _: 2 }, [
                        Pe(i(ne), (ce, ea) => ({
                          name: ce,
                          fn: se((Gt) => [
                            K(h.$slots, ce, Ne(ze({ ...Gt })))
                          ])
                        }))
                      ]), 1040, ["specific-mode", "get-week-num", "instance", "mapped-dates", "month", "year", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
                    ], 2))), 128))
                  ], 2),
                  ae("div", null, [
                    h.$slots["time-picker"] ? K(h.$slots, "time-picker", Ne(Se({ key: 0 }, { time: i(T), updateTime: i(y) }))) : (k(), I(me, { key: 1 }, [
                      h.enableTimePicker && !h.monthPicker && !h.weekPicker ? (k(), ve(Jr, Se({
                        key: 0,
                        ref_key: "timePickerRef",
                        ref: G,
                        hours: i(T).hours,
                        minutes: i(T).minutes,
                        seconds: i(T).seconds,
                        "internal-model-value": e.internalModelValue
                      }, i(o), {
                        onMount: j[5] || (j[5] = (J) => Ot("timePicker")),
                        "onUpdate:hours": j[6] || (j[6] = (J) => i(y)(J)),
                        "onUpdate:minutes": j[7] || (j[7] = (J) => i(y)(J, !1)),
                        "onUpdate:seconds": j[8] || (j[8] = (J) => i(y)(J, !1, !0)),
                        onResetFlow: R,
                        onOverlayClosed: ue,
                        onOverlayOpened: j[9] || (j[9] = (J) => h.$emit("time-picker-open", J))
                      }), Ve({ _: 2 }, [
                        Pe(i(Ge), (J, yt) => ({
                          name: J,
                          fn: se((ce) => [
                            K(h.$slots, J, Ne(ze(ce)))
                          ])
                        }))
                      ]), 1040, ["hours", "minutes", "seconds", "internal-model-value"])) : P("", !0)
                    ], 64))
                  ])
                ], 512),
                h.$slots["right-sidebar"] ? (k(), I("div", rl, [
                  K(h.$slots, "right-sidebar", Ne(ze({ handleMonthYearChange: ee })))
                ])) : P("", !0),
                h.$slots["action-extra"] ? (k(), I("div", ll, [
                  h.$slots["action-extra"] ? K(h.$slots, "action-extra", {
                    key: 0,
                    selectCurrentDate: i(f)
                  }) : P("", !0)
                ])) : P("", !0)
              ], 2),
              !h.autoApply || h.keepActionRow ? (k(), ve(pr, Se({
                key: 2,
                "menu-mount": U.value,
                "calendar-width": V.value,
                "internal-model-value": e.internalModelValue
              }, i(o), {
                onClosePicker: j[10] || (j[10] = (J) => h.$emit("close-picker")),
                onSelectDate: j[11] || (j[11] = (J) => h.$emit("select-date")),
                onInvalidSelect: j[12] || (j[12] = (J) => h.$emit("invalid-select")),
                onSelectNow: i(f)
              }), Ve({ _: 2 }, [
                Pe(i(Le), (J, yt) => ({
                  name: J,
                  fn: se((ce) => [
                    K(h.$slots, J, Ne(ze({ ...ce })))
                  ])
                }))
              ]), 1040, ["menu-mount", "calendar-width", "internal-model-value", "onSelectNow"])) : P("", !0)
            ], 42, el)
          ];
        }),
        _: 3
      }, 8, ["name", "css"]);
    };
  }
}), sl = typeof window < "u" ? window : void 0, ln = () => {
}, il = (e) => na() ? (aa(e), !0) : !1, ul = (e, n, a, t) => {
  if (!e)
    return ln;
  let o = ln;
  const v = nt(
    () => i(e),
    (N) => {
      o(), N && (N.addEventListener(n, a, t), o = () => {
        N.removeEventListener(n, a, t), o = ln;
      });
    },
    { immediate: !0, flush: "post" }
  ), g = () => {
    v(), o();
  };
  return il(g), g;
}, dl = (e, n, a, t = {}) => {
  const { window: o = sl, event: v = "pointerdown" } = t;
  return o ? ul(o, v, (N) => {
    const F = $e(e), C = $e(n);
    !F || !C || F === N.target || N.composedPath().includes(F) || N.composedPath().includes(C) || a(N);
  }, { passive: !0 }) : void 0;
}, cl = /* @__PURE__ */ je({
  __name: "VueDatePicker",
  props: {
    ...rt
  },
  emits: [
    "update:model-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open"
  ],
  setup(e, { expose: n, emit: a }) {
    const t = e, o = yn(), v = H(!1), g = St(t, "modelValue"), N = St(t, "timezone"), F = H(null), C = H(null), W = H(!1), _ = H(null), d = H(0), { setMenuFocused: $, setShiftKey: X } = Gn(), { clearArrowNav: G } = at(), { validateDate: x, isValidTime: V } = Ee(t);
    Ue(() => {
      b(t.modelValue), t.inline || (ue(_.value).addEventListener("scroll", l), window.addEventListener("resize", r)), t.inline && (v.value = !0);
    }), mn(() => {
      if (!t.inline) {
        const Q = ue(_.value);
        Q && Q.removeEventListener("scroll", l), window.removeEventListener("resize", r);
      }
    });
    const U = ft(o, "all", t.presetRanges), O = ft(o, "input");
    nt(
      [g, N],
      () => {
        b(g.value);
      },
      { deep: !0 }
    );
    const { openOnTop: Z, menuStyle: z, resetPosition: te, setMenuPosition: re, setInitialPosition: oe, getScrollableParent: ue } = sr(F, C, a, t), {
      inputValue: de,
      internalModelValue: R,
      parseExternalModelValue: b,
      emitModelValue: m,
      formatInputValue: B,
      checkBeforeEmit: Y
    } = lr(a, t, W), T = L(
      () => ({
        dp__main: !0,
        dp__theme_dark: t.dark,
        dp__theme_light: !t.dark,
        dp__flex_display: t.inline,
        dp__flex_display_with_input: t.inlineWithInput
      })
    ), y = L(() => t.dark ? "dp__theme_dark" : "dp__theme_light"), u = L(() => t.teleport ? {
      to: typeof t.teleport == "boolean" ? "body" : t.teleport,
      disabled: t.inline
    } : { class: "dp__outer_menu_wrap" }), l = () => {
      v.value && (t.closeOnScroll ? be() : re());
    }, r = () => {
      v.value && re();
    }, p = async () => {
      !t.disabled && !t.readonly && (te(), await Qe(), v.value = !0, await Qe(), oe(), d.value = Date.now(), await Qe(), re(), delete z.value.opacity, v.value && a("open"), v.value || le(), b(t.modelValue));
    }, w = () => {
      de.value = "", le(), a("update:model-value", null), a("cleared"), be();
    }, A = () => {
      const Q = R.value;
      return !Q || !Array.isArray(Q) && x(Q) ? !0 : Array.isArray(Q) ? Q.length === 2 && x(Q[0]) && x(Q[1]) ? !0 : x(Q[0]) : !1;
    }, c = () => {
      Y() && A() ? (m(), be()) : a("invalid-select", R.value);
    }, S = (Q) => {
      f(), m(), t.closeOnAutoApply && !Q && be();
    }, f = () => {
      C.value && t.textInput && C.value.setParsedDate(R.value);
    }, E = (Q = !1) => {
      t.autoApply && V(R.value) && A() && (t.range && Array.isArray(R.value) ? (t.partialRange || R.value.length === 2) && S(Q) : S(Q));
    }, le = () => {
      t.textInput || (R.value = null);
    }, be = () => {
      t.inline || (v.value && (v.value = !1, $(!1), X(!1), G(), a("closed"), oe(), de.value && b(g.value)), le());
    }, We = (Q, ye) => {
      if (!Q) {
        R.value = null;
        return;
      }
      R.value = Q, ye && (c(), a("text-submit"));
    }, ne = () => {
      t.autoApply && V(R.value) && m(), f();
    }, Le = () => v.value ? be() : p(), Ge = (Q) => {
      R.value = Q;
    }, Me = () => {
      t.textInput && (W.value = !0, B()), a("focus");
    }, He = () => {
      t.textInput && (W.value = !1, b(t.modelValue)), a("blur");
    }, lt = (Q) => {
      F.value && F.value.updateMonthYear(0, {
        month: In(Q.month),
        year: In(Q.year)
      });
    }, wt = (Q) => {
      b(Q || t.modelValue);
    };
    return dl(
      F,
      C,
      t.onClickOutside ? () => t.onClickOutside(A) : be
    ), n({
      closeMenu: be,
      selectDate: c,
      clearValue: w,
      openMenu: p,
      onScroll: l,
      formatInputValue: B,
      // exposed for testing purposes
      updateInternalModelValue: Ge,
      // modify internal modelValue
      setMonthYear: lt,
      parseModel: wt
    }), (Q, ye) => (k(), I("div", {
      class: he(i(T)),
      ref_key: "pickerWrapperRef",
      ref: _
    }, [
      tt(mr, Se({
        ref_key: "inputRef",
        ref: C,
        "is-menu-open": v.value,
        "input-value": i(de),
        "onUpdate:inputValue": ye[0] || (ye[0] = (fe) => ut(de) ? de.value = fe : null)
      }, Q.$props, {
        onClear: w,
        onOpen: p,
        onSetInputDate: We,
        onSetEmptyDate: i(m),
        onSelectDate: c,
        onToggle: Le,
        onClose: be,
        onFocus: Me,
        onBlur: He
      }), Ve({ _: 2 }, [
        Pe(i(O), (fe, ot) => ({
          name: fe,
          fn: se((st) => [
            K(Q.$slots, fe, Ne(ze(st)))
          ])
        }))
      ]), 1040, ["is-menu-open", "input-value", "onSetEmptyDate"]),
      v.value ? (k(), ve(Ln(Q.teleport ? ra : "div"), Ne(Se({ key: 0 }, i(u))), {
        default: se(() => [
          v.value ? (k(), ve(ol, Se({
            key: 0,
            ref_key: "dpMenuRef",
            ref: F,
            class: i(y),
            ready: d.value,
            style: Q.inline ? void 0 : i(z),
            "open-on-top": i(Z)
          }, Q.$props, {
            "internal-model-value": i(R),
            "onUpdate:internalModelValue": ye[1] || (ye[1] = (fe) => ut(R) ? R.value = fe : null),
            onClosePicker: be,
            onSelectDate: c,
            onAutoApply: E,
            onTimeUpdate: ne,
            onFlowStep: ye[2] || (ye[2] = (fe) => Q.$emit("flow-step", fe)),
            onUpdateMonthYear: ye[3] || (ye[3] = (fe) => Q.$emit("update-month-year", fe)),
            onInvalidSelect: ye[4] || (ye[4] = (fe) => Q.$emit("invalid-select", i(R))),
            onInvalidFixedRange: ye[5] || (ye[5] = (fe) => Q.$emit("invalid-fixed-range", fe)),
            onRecalculatePosition: i(re),
            onTooltipOpen: ye[6] || (ye[6] = (fe) => Q.$emit("tooltip-open", fe)),
            onTooltipClose: ye[7] || (ye[7] = (fe) => Q.$emit("tooltip-close", fe)),
            onTimePickerOpen: ye[8] || (ye[8] = (fe) => Q.$emit("time-picker-open", fe))
          }), Ve({ _: 2 }, [
            Pe(i(U), (fe, ot) => ({
              name: fe,
              fn: se((st) => [
                K(Q.$slots, fe, Ne(ze({ ...st })))
              ])
            }))
          ]), 1040, ["class", "ready", "style", "open-on-top", "internal-model-value", "onRecalculatePosition"])) : P("", !0)
        ]),
        _: 3
      }, 16)) : P("", !0)
    ], 2));
  }
}), Qn = /* @__PURE__ */ (() => {
  const e = cl;
  return e.install = (n) => {
    n.component("Vue3DatePicker", e);
  }, e;
})(), fl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Qn
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(fl).forEach(([e, n]) => {
  e !== "default" && (Qn[e] = n);
});
export {
  Qn as default
};
